<template>
  <div class="ai-chat">
    <!-- Header - shown when there are messages -->
    <header v-if="hasMessages" class="ai-chat__header ai-chat__header--compact">
      <div class="ai-chat__brand ai-chat__brand--compact">
        <div class="logo-wrap" id="logoWrap" aria-label="Logo">
          <img src="/assets/img/svg/misc/scout-logo.svg" alt="Scout AI from Insubuy" />
        </div>
        <h1 class="ai-chat__title ai-chat__title--compact">Scout AI</h1>
      </div>
      <p class="ai-chat__subtitle ai-chat__subtitle--compact">Ask me anything about travel/international insurance. Get answers and quotes in seconds</p>
    </header>

    <!-- Welcome Screen - shown when no messages -->
    <div v-show="showWelcomeScreen" class="ai-chat__welcome-screen">
      <div class="ai-chat__welcome-heading">
        <div class="ai-chat__welcome-logo logo-wrap">
          <svg
            width="178"
            height="180"
            viewBox="0 0 178 180"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.2"
              d="M97.3165 18.2599C133.049 32.2994 166.43 78.8534 152.39 114.586C138.351 150.318 82.2076 161.698 46.4752 147.659C10.7427 133.619 11.3822 100.432 25.4216 64.6993C39.4611 28.9669 61.584 4.22046 97.3165 18.2599Z"
              fill="url(#paint0_linear_420_1171)"
            />
            <path
              opacity="0.3"
              d="M161.225 108.561C165.422 69.8335 139.285 17.9164 100.557 13.7191C61.8291 9.52185 25.1759 54.6338 20.9786 93.3617C16.7813 132.09 46.9148 147.135 85.6427 151.332C124.371 155.529 157.028 147.289 161.225 108.561Z"
              fill="url(#paint1_linear_420_1171)"
            />
            <path
              d="M151.322 53.9978C161.258 91.0812 143.644 145.591 106.56 155.527C69.4769 165.464 26.9674 127.064 17.031 89.9809C7.09448 52.8975 34.1695 33.6946 71.2529 23.7581C108.336 13.8216 141.385 16.9143 151.322 53.9978Z"
              fill="#D9D9D9"
            />
            <path
              d="M151.322 53.9978C161.258 91.0812 143.644 145.591 106.56 155.527C69.4769 165.464 26.9674 127.064 17.031 89.9809C7.09448 52.8975 34.1695 33.6946 71.2529 23.7581C108.336 13.8216 141.385 16.9143 151.322 53.9978Z"
              fill="url(#paint2_linear_420_1171)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M89.6417 77.846C90.8498 69.481 92.131 59.3222 94.0713 48.2482L90.7033 47.4611C87.7564 69.8287 86.8045 80.8295 81.7709 81.7264C84.5348 77.2236 77.2315 62.9647 72.5639 73.3614L78.8239 81.3054C73.9184 79.4384 66.2124 72.0985 53.1615 59.7798L52.5575 65.4541C90.7582 94.521 90.0261 116.999 53.1615 94.0634L50.1413 94.3929C70.3491 113.96 90.2274 101.953 104.212 146.724L105.749 145.809C101.649 121.684 86.8045 98.3649 89.6417 77.8643V77.846Z"
              fill="url(#paint3_linear_420_1171)"
            />
            <path
              d="M52.5575 54.5448C60.5747 40.6153 84.3335 38.8765 105.658 50.6826C115.066 55.8993 122.406 62.8549 127 70.2131C123.12 60.7682 114.499 51.305 102.601 44.7155C81.2767 32.9276 57.4996 34.6665 49.4824 48.5959C44.9979 56.3752 46.4073 66.3327 52.2097 75.6678C49.1346 68.1997 49.0248 60.695 52.5575 54.5448Z"
              fill="url(#paint4_linear_420_1171)"
            />
            <mask
              id="mask0_420_1171"
              style="mask-type:alpha"
              maskUnits="userSpaceOnUse"
              x="24"
              y="29"
              width="105"
              height="103"
            >
              <path
                d="M126.099 55.2998C133.476 82.834 120.398 123.307 92.8635 130.685C65.3294 138.062 33.7664 109.551 26.3886 82.0171C19.0108 54.4829 39.1138 40.2248 66.648 32.8471C94.1822 25.4693 118.721 27.7656 126.099 55.2998Z"
                fill="#D9D9D9"
              />
              <path
                d="M126.099 55.2998C133.476 82.834 120.398 123.307 92.8635 130.685C65.3294 138.062 33.7664 109.551 26.3886 82.0171C19.0108 54.4829 39.1138 40.2248 66.648 32.8471C94.1822 25.4693 118.721 27.7656 126.099 55.2998Z"
                fill="url(#paint5_linear_420_1171)"
              />
            </mask>
            <g mask="url(#mask0_420_1171)">
              <mask
                id="mask1_420_1171"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="46"
                y="36"
                width="81"
                height="111"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M89.6417 77.846C90.8498 69.481 92.131 59.3222 94.0713 48.2482L90.7033 47.4611C87.7564 69.8287 86.8045 80.8295 81.7709 81.7264C84.5348 77.2236 77.2315 62.9647 72.5639 73.3614L78.8239 81.3054C73.9184 79.4384 66.2124 72.0985 53.1615 59.7798L52.5575 65.4541C90.7582 94.521 90.0261 116.999 53.1615 94.0634L50.1413 94.3929C70.3491 113.96 90.2274 101.953 104.212 146.724L105.749 145.809C101.649 121.684 86.8045 98.3649 89.6417 77.8643V77.846Z"
                  fill="#FAFCFF"
                />
                <path
                  d="M52.5575 54.5448C60.5747 40.6153 84.3335 38.8765 105.658 50.6826C115.066 55.8993 122.406 62.8549 127 70.2131C123.12 60.7682 114.499 51.305 102.601 44.7155C81.2767 32.9276 57.4996 34.6665 49.4824 48.5959C44.9979 56.3752 46.4073 66.3327 52.2097 75.6678C49.1346 68.1997 49.0248 60.695 52.5575 54.5448Z"
                  fill="#FAFCFF"
                />
              </mask>
              <g mask="url(#mask1_420_1171)">
                <path
                  d="M52.2884 65.4318L50.8511 65.7454L41.8086 92.6376L55.6075 128.703C72.4031 141.631 104.28 160.064 97.4224 130.376C88.8503 93.2649 70.6347 78.3683 63.3694 72.7233C57.5571 68.2073 53.5603 65.9806 52.2884 65.4318Z"
                  fill="url(#paint6_linear_420_1171)"
                />
              </g>
            </g>
            <g clip-path="url(#clip0_420_1171)">
              <path
                d="M127.043 87.4032C126.607 87.0971 126.039 86.9543 125.329 86.9543C124.173 86.9543 123.229 87.5562 122.509 88.7804C121.789 90.0045 121.181 91.5143 120.694 93.32C120.633 93.524 120.582 93.728 120.531 93.9218C120.034 95.9213 118.98 97.7269 117.438 99.0837C117.428 99.1041 117.407 99.1143 117.397 99.1245C117.397 99.1245 117.286 99.2265 117.093 99.3592C116.697 99.6346 115.987 100.063 115.308 100.053C115.004 100.053 114.851 99.9406 114.791 99.8896C114.527 99.6652 114.517 99.2571 114.517 99.0939C114.517 98.4104 115.095 95.299 116.028 91.0859C116.038 91.0247 116.058 90.9533 116.069 90.892C116.15 90.5656 116.221 90.1269 116.119 89.6475C116.119 89.6169 116.109 89.5761 116.099 89.5455C115.612 87.6276 112.711 86.6993 110.723 86.6279C107.143 86.5055 104.556 89.0558 103.573 90.0249C102.153 91.4225 101.443 92.8201 101.209 93.32C100.479 94.8604 100.124 96.5742 100.124 98.4614C100.124 100.349 100.611 101.807 101.595 102.991C101.808 103.246 102.031 103.47 102.284 103.674C103.197 104.409 104.364 104.776 105.794 104.776C106.788 104.776 107.691 104.511 108.512 103.98C109.182 103.562 109.8 102.96 110.348 102.175L111.038 101.216C111.078 101.716 111.21 102.165 111.454 102.583C111.626 102.909 111.869 103.215 112.174 103.501C112.316 103.634 112.478 103.756 112.63 103.848C112.681 103.889 112.732 103.909 112.782 103.94C112.985 104.062 113.198 104.144 113.401 104.215C113.472 104.246 113.543 104.266 113.624 104.286C113.685 104.307 113.756 104.317 113.827 104.337C113.939 104.358 114.05 104.378 114.172 104.399C114.243 104.399 114.314 104.419 114.385 104.429C114.436 104.439 114.486 104.439 114.547 104.439C114.598 104.45 114.649 104.45 114.689 104.45C114.841 104.46 114.963 104.46 115.044 104.46C115.217 104.46 115.389 104.45 115.551 104.429C115.693 104.419 115.835 104.399 115.977 104.368C116.241 104.317 116.505 104.246 116.779 104.154C116.88 104.123 116.971 104.082 117.063 104.042C117.184 104.001 117.306 103.94 117.438 103.878C117.58 103.807 117.712 103.736 117.844 103.674C118.28 103.429 118.625 103.195 118.868 103.021C119.03 102.899 119.253 102.736 119.537 102.522C119.892 102.236 120.217 101.95 120.531 101.665C120.552 101.665 120.562 101.644 120.572 101.624C121.525 100.461 122.205 99.0837 122.57 97.6045C122.621 97.4005 122.672 97.1965 122.722 97.0026C123.209 95.197 123.818 93.6872 124.538 92.4631C125.157 91.4123 125.938 90.8206 126.871 90.6778C127.053 90.3106 127.236 89.9331 127.439 89.5455C127.621 89.1986 127.702 88.8212 127.702 88.4335C127.702 88.0459 127.489 87.699 127.043 87.4032ZM110.825 95.5949C110.48 97.2271 109.922 98.4206 109.171 99.1755C108.421 99.9304 107.64 100.308 106.808 100.318H106.768C105.358 100.318 104.658 99.4918 104.658 97.829C104.658 96.1661 105.368 94.4421 106.798 92.6773C106.859 92.6059 106.92 92.5243 106.991 92.4529C108.259 90.9635 109.8 90.1065 111.585 89.9025C111.809 89.8821 111.991 90.0963 111.951 90.3106V90.3412L111.078 94.4013L110.825 95.5949Z"
                fill="white"
              />
              <path
                d="M127.043 87.4032C126.607 87.0971 126.039 86.9543 125.329 86.9543C124.173 86.9543 123.229 87.5562 122.509 88.7804C121.789 90.0045 121.181 91.5143 120.694 93.32C120.633 93.524 120.582 93.728 120.531 93.9218C120.034 95.9213 118.98 97.7269 117.438 99.0837C117.428 99.1041 117.407 99.1143 117.397 99.1245C117.397 99.1245 117.286 99.2265 117.093 99.3592C116.697 99.6346 115.987 100.063 115.308 100.053C115.004 100.053 114.851 99.9406 114.791 99.8896C114.527 99.6652 114.517 99.2571 114.517 99.0939C114.517 98.4104 115.095 95.299 116.028 91.0859C116.038 91.0247 116.058 90.9533 116.069 90.892C116.15 90.5656 116.221 90.1269 116.119 89.6475C116.119 89.6169 116.109 89.5761 116.099 89.5455C115.612 87.6276 112.711 86.6993 110.723 86.6279C107.143 86.5055 104.556 89.0558 103.573 90.0249C102.153 91.4225 101.443 92.8201 101.209 93.32C100.479 94.8604 100.124 96.5742 100.124 98.4614C100.124 100.349 100.611 101.807 101.595 102.991C101.808 103.246 102.031 103.47 102.284 103.674C103.197 104.409 104.364 104.776 105.794 104.776C106.788 104.776 107.691 104.511 108.512 103.98C109.182 103.562 109.8 102.96 110.348 102.175L111.038 101.216C111.078 101.716 111.21 102.165 111.454 102.583C111.626 102.909 111.869 103.215 112.174 103.501C112.316 103.634 112.478 103.756 112.63 103.848C112.681 103.889 112.732 103.909 112.782 103.94C112.985 104.062 113.198 104.144 113.401 104.215C113.472 104.246 113.543 104.266 113.624 104.286C113.685 104.307 113.756 104.317 113.827 104.337C113.939 104.358 114.05 104.378 114.172 104.399C114.243 104.399 114.314 104.419 114.385 104.429C114.436 104.439 114.486 104.439 114.547 104.439C114.598 104.45 114.649 104.45 114.689 104.45C114.841 104.46 114.963 104.46 115.044 104.46C115.217 104.46 115.389 104.45 115.551 104.429C115.693 104.419 115.835 104.399 115.977 104.368C116.241 104.317 116.505 104.246 116.779 104.154C116.88 104.123 116.971 104.082 117.063 104.042C117.184 104.001 117.306 103.94 117.438 103.878C117.58 103.807 117.712 103.736 117.844 103.674C118.28 103.429 118.625 103.195 118.868 103.021C119.03 102.899 119.253 102.736 119.537 102.522C119.892 102.236 120.217 101.95 120.531 101.665C120.552 101.665 120.562 101.644 120.572 101.624C121.525 100.461 122.205 99.0837 122.57 97.6045C122.621 97.4005 122.672 97.1965 122.722 97.0026C123.209 95.197 123.818 93.6872 124.538 92.4631C125.157 91.4123 125.938 90.8206 126.871 90.6778C127.053 90.3106 127.236 89.9331 127.439 89.5455C127.621 89.1986 127.702 88.8212 127.702 88.4335C127.702 88.0459 127.489 87.699 127.043 87.4032ZM110.825 95.5949C110.48 97.2271 109.922 98.4206 109.171 99.1755C108.421 99.9304 107.64 100.308 106.808 100.318H106.768C105.358 100.318 104.658 99.4918 104.658 97.829C104.658 96.1661 105.368 94.4421 106.798 92.6773C106.859 92.6059 106.92 92.5243 106.991 92.4529C108.259 90.9635 109.8 90.1065 111.585 89.9025C111.809 89.8821 111.991 90.0963 111.951 90.3106V90.3412L111.078 94.4013L110.825 95.5949Z"
                fill="url(#paint7_linear_420_1171)"
                fill-opacity="0.2"
              />
              <path
                d="M134.723 98.4308C134.723 98.9102 134.489 99.4305 134.033 100.002C132.765 101.522 131.375 102.685 129.844 103.501C129.215 103.837 128.576 104.103 127.947 104.297C127.044 104.582 126.132 104.725 125.229 104.725C123.677 104.725 122.409 104.144 121.425 102.991C121.091 102.603 120.817 102.175 120.604 101.695C120.594 101.675 120.583 101.644 120.573 101.624C121.527 100.461 122.206 99.0837 122.571 97.6045C122.622 97.4004 122.673 97.1964 122.724 97.0026C123.21 95.197 123.819 93.6872 124.539 92.463C125.158 91.4123 125.939 90.8206 126.872 90.6778C125.614 93.3709 124.965 95.7682 124.925 97.8697C124.914 97.9513 124.914 98.0227 124.914 98.0941C124.914 99.859 125.452 100.736 126.547 100.736C126.689 100.736 126.842 100.726 127.004 100.695C128.221 100.461 129.722 99.3081 131.507 97.2372C131.822 96.819 132.238 96.6047 132.765 96.6047C133.292 96.6047 133.749 96.7884 134.144 97.1556C134.53 97.5331 134.723 97.9615 134.723 98.4308Z"
                fill="white"
              />
              <path
                d="M134.723 98.4308C134.723 98.9102 134.489 99.4305 134.033 100.002C132.765 101.522 131.375 102.685 129.844 103.501C129.215 103.837 128.576 104.103 127.947 104.297C127.044 104.582 126.132 104.725 125.229 104.725C123.677 104.725 122.409 104.144 121.425 102.991C121.091 102.603 120.817 102.175 120.604 101.695C120.594 101.675 120.583 101.644 120.573 101.624C121.527 100.461 122.206 99.0837 122.571 97.6045C122.622 97.4004 122.673 97.1964 122.724 97.0026C123.21 95.197 123.819 93.6872 124.539 92.463C125.158 91.4123 125.939 90.8206 126.872 90.6778C125.614 93.3709 124.965 95.7682 124.925 97.8697C124.914 97.9513 124.914 98.0227 124.914 98.0941C124.914 99.859 125.452 100.736 126.547 100.736C126.689 100.736 126.842 100.726 127.004 100.695C128.221 100.461 129.722 99.3081 131.507 97.2372C131.822 96.819 132.238 96.6047 132.765 96.6047C133.292 96.6047 133.749 96.7884 134.144 97.1556C134.53 97.5331 134.723 97.9615 134.723 98.4308Z"
                fill="url(#paint8_linear_420_1171)"
                fill-opacity="0.7"
              />
              <path
                d="M129.226 83.0268C130.615 85.465 131.741 85.0875 130.706 82.5066C133.506 83.5063 133.942 82.4148 131.285 81.0784C133.942 78.1812 132.441 76.7632 129.327 79.2013C128.11 76.7632 126.923 77.1713 127.785 79.7522C124.986 78.8545 124.489 79.9562 127.146 81.211C124.489 84.0878 126.081 85.465 129.236 83.0268H129.226Z"
                fill="#FEEDC7"
              />
              <path
                d="M129.226 83.0268C130.615 85.465 131.741 85.0875 130.706 82.5066C133.506 83.5063 133.942 82.4148 131.285 81.0784C133.942 78.1812 132.441 76.7632 129.327 79.2013C128.11 76.7632 126.923 77.1713 127.785 79.7522C124.986 78.8545 124.489 79.9562 127.146 81.211C124.489 84.0878 126.081 85.465 129.236 83.0268H129.226Z"
                fill="url(#paint9_linear_420_1171)"
                fill-opacity="0.7"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_420_1171"
                x1="178.81"
                y1="91.3247"
                x2="192.291"
                y2="32.3123"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FDBA21" />
                <stop offset="1" stop-color="#FF6700" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_420_1171"
                x1="158.334"
                y1="126.529"
                x2="123.572"
                y2="168.285"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FDBA21" />
                <stop offset="1" stop-color="#FF6700" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_420_1171"
                x1="106.56"
                y1="155.527"
                x2="71.2529"
                y2="23.7581"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#004CC7" />
                <stop offset="1" stop-color="#0078FF" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_420_1171"
                x1="74.02"
                y1="36.8968"
                x2="99.8144"
                y2="146.724"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="1" stop-color="#DDEDFF" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_420_1171"
                x1="74.02"
                y1="36.8968"
                x2="99.8144"
                y2="146.724"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="1" stop-color="#DDEDFF" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_420_1171"
                x1="92.8636"
                y1="130.685"
                x2="66.648"
                y2="32.8471"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#004CC7" />
                <stop offset="1" stop-color="#0078FF" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_420_1171"
                x1="70.0914"
                y1="65.4318"
                x2="70.0914"
                y2="146.337"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="1" stop-color="#0078FF" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_420_1171"
                x1="112.835"
                y1="86.8081"
                x2="108.056"
                y2="91.3959"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FDBA21" />
                <stop offset="1" stop-color="#FF6700" />
              </linearGradient>
              <linearGradient
                id="paint8_linear_420_1171"
                x1="131.811"
                y1="113.262"
                x2="121.216"
                y2="82.428"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F9CDAF" />
                <stop offset="1" stop-color="#FDBA21" />
              </linearGradient>
              <linearGradient
                id="paint9_linear_420_1171"
                x1="131.483"
                y1="88.9702"
                x2="126.433"
                y2="73.1957"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F9CDAF" />
                <stop offset="1" stop-color="#FDBA21" />
              </linearGradient>
              <clipPath id="clip0_420_1171">
                <rect
                  width="34.8407"
                  height="28.0333"
                  fill="white"
                  transform="translate(99.9678 77.3155)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="ai-chat__welcome-text">
          <h1 class="ai-chat__welcome-title">Welcome to Scout AI from&nbsp;Insubuy!</h1>
          <!-- Mobile -->
          <p class="ai-chat__welcome-description">
            <span>Ask me anything about travel/international insurance. Need a quote?</span>
            <span>Tell me your destination, travel dates, and travelers' ages to&nbsp;get&nbsp;started!</span>
          </p>
        </div>
      </div>

      <!-- How Does Scout AI Work Section -->
      <div class="ai-chat__how-it-work">
        <h4 class="ai-chat__how-it-work-text">How does Scout AI work?</h4>
        <a href="javascript:void(0)" class="ai-chat__how-it-work-icon-wrapper" @click.prevent="openScoutPromoVideo">
          <p class="ai-chat__how-it-work-icon-text">Watch Now</p>
          <img class="ai-chat__how-it-work-icon" src="/assets/img/svg/scout/youtube_white_icon.svg" alt="How does Scout AI work?" />
        </a>
      </div>

      <div class="ai-chat__faq-cards">
        <div
          v-for="(card, index) in faqCards"
          :key="index"
          class="ai-chat__faq-card"
          @click="handleFaqClick(card.title)"
          role="button"
          tabindex="0"
          @keydown.enter="handleFaqClick(card.title)"
        >
          <div class="ai-chat__faq-card-icon">
            <!-- Placeholder for icon -->
            <div class="ai-chat__faq-card-icon-placeholder" :class="'ai-chat__faq-card-icon-placeholder--'+card.icon"></div>
          </div>
          <div class="ai-chat__faq-card-content">
            <h3 class="ai-chat__faq-card-title">{{ card.title }}</h3>
            <p class="ai-chat__faq-card-description">{{ card.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Layout wrapper for sidebar support -->
    <div v-show="!showWelcomeScreen" class="ai-chat__layout">
      <!-- Main content area -->
      <div class="ai-chat__content">
        <!-- Chat area -->
        <main class="ai-chat__main" role="log" aria-live="polite" ref="scrollWrap">
          <div
            v-for="(m, idx) in messages"
            :key="m.id"
            class="ai-chat__message-group"
            :class="{
              'ai-chat__message-group--user': m.role==='user',
              'ai-chat__message-group--assistant': m.role==='assistant'
            }"
          >
            <!-- User Message -->
            <div v-if="m.role==='user'" class="ai-chat__message-container">
              <div class="ai-chat__message-content">
                <div class="ai-chat__bubble ai-chat__bubble--user">
                  <div class="ai-chat__text ai-chat__markdown" v-html="formatText(m.text)"></div>
                </div>
                <div class="ai-chat__message-meta">
                  <span class="ai-chat__timestamp">{{ formatTimestamp(m.timestamp) }}</span>
                  <button
                    v-if="m.needsRetry"
                    class="ai-chat__retry-btn"
                    @click="retryMessage(m)"
                    :disabled="isTyping"
                    aria-label="Retry message"
                    title="Click to resend this question"
                  >
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="ai-chat__retry-icon">
                      <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.8273 3 17.35 4.37264 19 6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <path d="M21 3V7H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <!-- Assistant Message -->
            <div v-else class="ai-chat__message-container ai-chat__message-container--assistant" @click="handleAiChatActionClick">
              <div class="ai-chat__avatar ai-chat__avatar--assistant">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <g clip-path="url(#clip0_472_454)">
                    <rect width="40" height="40" rx="20" fill="white"/>
                    <rect width="40" height="40" rx="20" fill="#004CC7" fill-opacity="0.07"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.4764 20.0385C23.8786 17.2034 24.3051 13.7604 24.9511 10.0072L23.8298 9.74044C22.8488 17.3213 22.5319 21.0497 20.8562 21.3536C21.7763 19.8275 19.345 14.9949 17.7911 18.5186L19.8751 21.211C18.242 20.5782 15.6766 18.0905 11.3319 13.9155L11.1308 15.8386C23.8481 25.69 23.6044 33.308 11.3319 25.5349L10.3265 25.6465C17.0538 32.2782 23.6714 28.2086 28.3269 43.3827L28.8388 43.0725C27.4738 34.8962 22.5319 26.9927 23.4764 20.0447V20.0385Z" fill="#004CC7"/>
                    <path d="M11.1308 12.1412C13.7998 7.42028 21.7093 6.83094 28.8083 10.8323C31.9404 12.6003 34.3839 14.9577 35.9134 17.4516C34.6216 14.2505 31.7515 11.0432 27.7907 8.8099C20.6917 4.81476 12.7761 5.4041 10.1071 10.1251C8.61418 12.7616 9.08338 16.1364 11.015 19.3002C9.99133 16.7692 9.95477 14.2257 11.1308 12.1412Z" fill="#004CC7"/>
                  </g>
                  <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#004CC7" stroke-opacity="0.07"/>
                  <defs>
                    <clipPath id="clip0_472_454">
                      <rect width="40" height="40" rx="20" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="ai-chat__message-content" @click="handleComparePurchaseClick">
                <!-- Show streaming effect only for new messages, not restored ones -->
                <streaming-message
                  v-if="!m.skipStreaming"
                  class="ai-chat__bubble ai-chat__bubble--assistant ai-chat__markdown"
                  :fullText="formatAssistantHtml(m)"
                  mode="word"
                  :chunkMs="18"
                  @update="onStreamingUpdate"
                  @done="onMessageDone"
                />
                <!-- Show instant text for restored messages -->
                <div
                  v-else
                  class="ai-chat__bubble ai-chat__bubble--assistant ai-chat__markdown"
                  v-html="formatAssistantHtml(m)"
                ></div>
                <div class="ai-chat__message-meta">
                  <span class="ai-chat__timestamp">{{ formatTimestamp(m.timestamp) }}</span>
                  <div class="ai-chat__feedback-buttons" v-if="idx > 0">
                    <button
                      class="ai-chat__feedback-btn"
                      :class="{ 'ai-chat__feedback-btn--active': m.feedback === 'up' }"
                      @click="submitFeedback(m, 'up')"
                      :disabled="m.feedback !== null"
                      aria-label="Helpful"
                      title="Helpful"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="currentColor">
                        <path d="M8.125 0.0842285C8.91524 -0.207253 9.90766 0.3027 10.4424 0.930908C10.72 1.25953 10.9193 1.64754 11.0244 2.0647C11.1295 2.48196 11.1378 2.91811 11.0488 3.33911L10.6475 5.34595H12.8525C13.1984 5.34455 13.5406 5.42413 13.8506 5.57739C14.1604 5.73064 14.4309 5.95329 14.6396 6.22876C14.8501 6.50261 14.9934 6.82237 15.0596 7.16138C15.1257 7.5003 15.1126 7.85006 15.0205 8.18286L13.9922 11.9534C13.7979 12.6604 13.3767 13.2846 12.7939 13.7297C12.2111 14.1749 11.498 14.4169 10.7646 14.4182H5.62988C5.52537 14.4182 5.42291 14.3873 5.33594 14.3293L3.77148 13.2854C3.57815 13.6919 3.25255 14.0204 2.84766 14.217C2.44273 14.4136 1.98293 14.4669 1.54395 14.3674C1.10492 14.2679 0.712255 14.0222 0.431641 13.6702C0.151099 13.3182 -0.000765403 12.881 0 12.4309V6.59985C-0.000531827 6.14369 0.155958 5.70116 0.443359 5.34692C0.730783 4.99268 1.13162 4.748 1.57812 4.65454C2.02439 4.56117 2.48933 4.62427 2.89453 4.83325C3.2999 5.04247 3.62124 5.38586 3.80371 5.80396C4.92974 5.14274 7.28796 3.51865 7.28809 1.5022C7.25389 1.207 7.31674 0.908511 7.46777 0.652588C7.61888 0.396627 7.84995 0.196923 8.125 0.0842285ZM8.48926 1.07739C8.36385 1.1229 8.34474 1.36204 8.34473 1.50024C8.34473 4.35007 5.00713 6.36713 3.97266 6.92407V12.1477L5.78906 13.3586H10.7656C11.2667 13.3577 11.754 13.192 12.1523 12.8879C12.5507 12.5838 12.8388 12.1573 12.9717 11.6741L14 7.90356L13.998 7.90552C14.0462 7.72922 14.0526 7.54386 14.0176 7.3645C13.9825 7.18522 13.9068 7.0165 13.7959 6.87134C13.6849 6.72612 13.5418 6.60854 13.3779 6.52759C13.2142 6.44671 13.0342 6.40447 12.8516 6.40454H10C9.9217 6.40456 9.84422 6.38723 9.77344 6.35376C9.70259 6.32016 9.63947 6.27091 9.58984 6.21021C9.54026 6.14949 9.50417 6.0783 9.48535 6.0022C9.46656 5.92597 9.46574 5.84573 9.48145 5.7688L10.0107 3.12915C10.0653 2.86527 10.0601 2.59183 9.99512 2.33032C9.93014 2.06895 9.80634 1.82601 9.63477 1.61841C9.50123 1.44279 9.32744 1.30146 9.12793 1.20728C8.92856 1.11321 8.70954 1.06892 8.48926 1.07739ZM1.98633 5.64966C1.86265 5.64968 1.73996 5.67391 1.62598 5.72192C1.51199 5.76995 1.40868 5.84046 1.32227 5.92896C1.2359 6.01741 1.16834 6.12252 1.12305 6.23755C1.07775 6.3527 1.05564 6.47615 1.05859 6.59985V12.4309C1.06443 12.673 1.16467 12.9033 1.33789 13.0725C1.51121 13.2417 1.74409 13.3361 1.98633 13.3362C2.22861 13.3362 2.4614 13.2418 2.63477 13.0725C2.80808 12.9033 2.90822 12.6731 2.91406 12.4309V6.59985C2.91702 6.47615 2.89588 6.3527 2.85059 6.23755C2.80529 6.12244 2.73681 6.01747 2.65039 5.92896C2.56399 5.84052 2.46063 5.76992 2.34668 5.72192C2.2327 5.67395 2.10999 5.64966 1.98633 5.64966Z"/>
                      </svg>
                    </button>
                    <button
                      class="ai-chat__feedback-btn ai-chat__feedback-btn--dislike"
                      :class="{ 'ai-chat__feedback-btn--active': m.feedback === 'down' }"
                      @click="submitFeedback(m, 'down')"
                      :disabled="m.feedback !== null"
                      aria-label="Not helpful"
                      title="Not helpful"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="currentColor">
                        <path d="M9.47162 0C9.57593 -4.42813e-05 9.6779 0.0308378 9.76459 0.0888672L11.329 1.13184C11.4897 0.794256 11.7428 0.508717 12.0585 0.308594C12.3743 0.108527 12.7404 0.00205955 13.1142 0.000976562C13.6409 0.00154339 14.146 0.210637 14.5185 0.583008C14.891 0.955384 15.1008 1.46062 15.1015 1.9873V7.81836C15.1004 8.273 14.9431 8.71374 14.6562 9.06641C14.3692 9.4191 13.9693 9.66237 13.5244 9.75586C13.0794 9.84928 12.6155 9.78746 12.2109 9.58008C11.8062 9.37257 11.4846 9.03212 11.3007 8.61621C10.1746 9.27751 7.81666 10.9008 7.81635 12.917C7.85054 13.2122 7.78676 13.5107 7.63568 13.7666C7.4846 14.0225 7.25441 14.2223 6.97943 14.335C6.82321 14.3913 6.65819 14.4199 6.49213 14.4189C6.14 14.3954 5.79587 14.3008 5.48138 14.1406C5.16685 13.9804 4.88816 13.7574 4.66205 13.4863C4.3847 13.1581 4.18535 12.7711 4.08002 12.3545C3.9747 11.9377 3.96551 11.5018 4.05365 11.0811L4.45599 9.07422H2.24994C1.90434 9.07455 1.56279 8.99569 1.25287 8.84277C0.942962 8.68984 0.672818 8.46686 0.46283 8.19238C0.252886 7.91792 0.108459 7.59885 0.0419312 7.25977C-0.0245708 6.92057 -0.0117495 6.56984 0.0790405 6.23633L1.10638 2.46387C1.30075 1.75639 1.72236 1.13262 2.3056 0.6875C2.88894 0.242348 3.60209 0.000708777 4.33588 0H9.47162ZM4.33588 1.05957C3.83475 1.06035 3.34748 1.22521 2.94916 1.5293C2.55078 1.83349 2.26355 2.2608 2.1308 2.74414L1.10052 6.5127C1.0524 6.68898 1.04596 6.87437 1.08099 7.05371C1.11601 7.23295 1.19184 7.40172 1.30267 7.54688C1.4136 7.69206 1.55685 7.80967 1.72064 7.89062C1.88435 7.97151 2.06441 8.0137 2.24701 8.01367H5.09955C5.17804 8.01358 5.25613 8.0309 5.32709 8.06445C5.39806 8.09805 5.46097 8.14722 5.51068 8.20801C5.5604 8.26883 5.59537 8.34072 5.6142 8.41699C5.63294 8.49316 5.63477 8.57256 5.61908 8.64941L5.08978 11.2891C5.03534 11.553 5.04133 11.8264 5.10638 12.0879C5.17146 12.3493 5.29406 12.5932 5.46576 12.8008C5.59935 12.9761 5.77331 13.1167 5.9726 13.2109C6.17191 13.3052 6.39095 13.3499 6.61127 13.3418C6.73659 13.2963 6.75575 13.0572 6.7558 12.9189V12.917C6.75612 10.0674 10.0932 8.05105 11.1308 7.49414V2.27051L9.31244 1.05957H4.33588ZM13.1161 1.11328C12.8795 1.11328 12.6516 1.20394 12.4794 1.36621C12.3072 1.52864 12.2032 1.75097 12.1894 1.9873V7.81836C12.182 7.94441 12.2 8.07078 12.2431 8.18945C12.2863 8.30815 12.3538 8.41687 12.4404 8.50879C12.5271 8.60076 12.6319 8.67452 12.748 8.72461C12.8641 8.7747 12.9897 8.80078 13.1161 8.80078C13.2424 8.80073 13.3674 8.77462 13.4833 8.72461C13.5994 8.67452 13.7042 8.60078 13.791 8.50879C13.8776 8.41685 13.945 8.30819 13.9882 8.18945C14.0314 8.07075 14.0493 7.94444 14.0419 7.81836V1.9873C14.0281 1.75104 13.925 1.52863 13.7529 1.36621C13.5807 1.20387 13.3528 1.11338 13.1161 1.11328Z"/>
                      </svg>
                    </button>
                  </div>
                  <transition name="ai-chat__feedback-thanks">
                    <span v-if="m.feedbackSubmitted" class="ai-chat__feedback-thanks" :class="{'ai-chat__feedback-thanks--down': m.feedback === 'down'}">
                      Thanks for your feedback!
                    </span>
                  </transition>
                </div>
              </div>
            </div>

            <!-- Plan Blocks for this message -->
            <plan-blocks
              v-if="m.role==='assistant' && m.plans && m.plans.length > 0"
              :plans="m.plans" 
              :criteria="criteria"
              :quote-link="m.quoteLink"
              :section="m.section" 
              :policy-max="m.policyMax"
              :deductible="m.ded"
              @share-quotes="openShareModal"
              @view-all-results="handleViewAllResults"
            />
          </div>

          <!-- Typing indicator -->
          <div v-if="isTyping" class="ai-chat__row ai-chat__row--assistant">
            <div class="ai-chat__avatar ai-chat__avatar--assistant">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <g clip-path="url(#clip0_472_454)">
                  <rect width="40" height="40" rx="20" fill="white"/>
                  <rect width="40" height="40" rx="20" fill="#004CC7" fill-opacity="0.07"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M23.4764 20.0385C23.8786 17.2034 24.3051 13.7604 24.9511 10.0072L23.8298 9.74044C22.8488 17.3213 22.5319 21.0497 20.8562 21.3536C21.7763 19.8275 19.345 14.9949 17.7911 18.5186L19.8751 21.211C18.242 20.5782 15.6766 18.0905 11.3319 13.9155L11.1308 15.8386C23.8481 25.69 23.6044 33.308 11.3319 25.5349L10.3265 25.6465C17.0538 32.2782 23.6714 28.2086 28.3269 43.3827L28.8388 43.0725C27.4738 34.8962 22.5319 26.9927 23.4764 20.0447V20.0385Z" fill="#004CC7"/>
                  <path d="M11.1308 12.1412C13.7998 7.42028 21.7093 6.83094 28.8083 10.8323C31.9404 12.6003 34.3839 14.9577 35.9134 17.4516C34.6216 14.2505 31.7515 11.0432 27.7907 8.8099C20.6917 4.81476 12.7761 5.4041 10.1071 10.1251C8.61418 12.7616 9.08338 16.1364 11.015 19.3002C9.99133 16.7692 9.95477 14.2257 11.1308 12.1412Z" fill="#004CC7"/>
                </g>
                <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#004CC7" stroke-opacity="0.07"/>
                <defs>
                  <clipPath id="clip0_472_454">
                    <rect width="40" height="40" rx="20" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="ai-chat__typing-container">
              <div class="ai-chat__bubble ai-chat__bubble--typing" aria-label="Assistant is typing">
                <span class="dot"></span><span class="dot"></span><span class="dot"></span>
              </div>
              <p class="ai-chat__loading-message">{{ currentLoadingMessage }}</p>
            </div>
          </div>

          <!-- Error -->
          <div v-if="error" class="ai-chat__error" role="alert">
            {{ error }}
          </div>

          <!-- Session Expired Message -->
          <div v-if="sessionExpired" class="ai-chat__session-expired">
            <div class="ai-chat__session-expired-header">
              <div class="ai-chat__session-expired-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
              <h3 class="ai-chat__session-expired-title">Daily Usage Limit Reached</h3>
            </div>

            <div class="ai-chat__session-expired-content">
              <p class="ai-chat__session-expired-message">
                Thank you for trying our BETA version of the AI Quote Assistant! To ensure the best experience for all users, we currently limit daily usage.
              </p>
              <p class="ai-chat__session-expired-message ai-chat__session-expired-message--bold">
                You can still continue to explore insurance plans:
              </p>

              <div class="ai-chat__session-expired-options">
                <p class="ai-chat__session-expired-option">• Visit our <a href="/" class="ai-chat__session-expired-link">home page</a> and select your insurance type</p>
                <p class="ai-chat__session-expired-option">• Use our traditional <a href="/get-travel-insurance-quotes/" @click.prevent="showInsuranceModal=true" class="ai-chat__session-expired-link">quote form</a></p>
                <p class="ai-chat__session-expired-option">• Call us at <a href="tel:1-866-467-8289" class="ai-chat__session-expired-link">+1 (866) 467-8289</a> to speak with a licensed agent</p>
              </div>

              <div class="ai-chat__session-expired-actions">
                <a href="/insurance-plans/" class="o-Btn o-Btn--green">
                  Browse Plans
                </a>
                <a href="tel:1-866-467-8289" class="o-Btn o-Btn--white-orange">
                  Call Us Now
                </a>
              </div>
            </div>
          </div>

          <!-- Conversation-level feedback (lazy; shown once per session) -->
          <ai-chat-csat
            v-if="showCsat"
            :rating="csatRating"
            :submitted="csatSubmitted"
            @select="openCsatModal"
            @dismiss="dismissCsat"
          />
        </main>
      </div><!-- /.ai-chat__content -->
      <!-- Sidebar slot (for CTS suggested questions) -->
      <aside v-if="$slots.sidebar" class="ai-chat__sidebar">
        <slot name="sidebar"></slot>
      </aside>
    </div><!-- /.ai-chat__layout -->

    <!-- Sticky Footer Area -->
    <div class="ai-chat__footer-container" :class="{'ai-chat__footer-container--se': sessionExpired}">
      <!-- Composer -->
      <footer class="ai-chat__composer">
        <div v-show="!sessionExpired"  class="ai-chat__composer-box" :class="{ 'ai-chat__composer-box--focused': showFaqSuggestions, 'ai-chat__composer-box--large': isComposerLarge }">
          <!-- Text input area -->
          <div class="ai-chat__input-area">
            <textarea
              id="ai-chat__input"
              ref="txtinput"
              v-model.trim="draft"
              class="ai-chat__input"
              placeholder="Ask Scout AI"
              rows="1"
              maxlength="2000"
              @keydown.enter.exact.prevent="handleEnter"
              @keydown.enter.shift="insertNewline"
              @focus="handleInputFocus"
              @blur="handleInputBlur"
              :disabled="isTyping || isListening"
            ></textarea>

            <!-- FAQ Suggestions - shown when focused but no messages -->
            <div
              v-show="showFaqSuggestions"
              ref="faqDropdown"
              class="ai-chat__faq-dropdown ai-chat__faq-dropdown--above"
            >
              <!-- FAQ Items -->
              <div
                v-for="(suggestion, index) in filteredFaqSuggestions"
                :key="index"
                class="ai-chat__faq-item"
                @click="handleFaqClick(suggestion)"
                role="button"
                tabindex="0"
                @keydown.enter="handleFaqClick(suggestion)"
              >
                {{ suggestion }}
              </div>

              <!-- Divider -->
              <div class="ai-chat__faq-dropdown-divider"></div>

            </div>
          </div>

          <!-- Bottom action row -->
          <div class="ai-chat__bottom-row">
            <!-- Left: Read Aloud (auto-enabled when voice input is used, session-only) -->
            <button
              @click="toggleReadAloud"
              class="ai-chat__read-aloud-btn"
              :class="{ 'ai-chat__read-aloud-btn--active': voiceEnabled || voiceInputUsed, 'ai-chat__read-aloud-btn--inactive': toggleInactiveSpk }"
              :title="(voiceEnabled || voiceInputUsed) ? 'Read aloud enabled' : 'Read aloud disabled'"
              aria-label="Toggle read aloud"
            >
              <div class="ai-chat__icon-read-aloud">
                <svg v-if="voiceEnabled || voiceInputUsed" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                  <path d="M11.2295 0.0022583C11.3264 0.0109318 11.4198 0.0434418 11.501 0.0969849C11.5822 0.150614 11.6482 0.224152 11.6943 0.309875C11.7404 0.395512 11.7647 0.490971 11.7646 0.588196V18.2357C11.7646 18.3329 11.7404 18.4284 11.6943 18.514C11.6482 18.5997 11.5813 18.6733 11.5 18.7269C11.4188 18.7803 11.3253 18.813 11.2285 18.8216C11.1318 18.8301 11.0346 18.8139 10.9453 18.7757L10.29 18.4954C8.02066 17.5181 6.01375 16.0178 4.43457 14.1175H1.89062C1.3896 14.117 0.909011 13.918 0.554688 13.5638C0.200345 13.2094 0.000467241 12.729 0 12.2278V6.59601C0.000488329 6.09492 0.200364 5.61439 0.554688 5.26007C0.909007 4.90588 1.38962 4.70683 1.89062 4.70636H4.43457C6.01349 2.80619 8.01991 1.30642 10.2891 0.329407L10.9453 0.0481567C11.0348 0.00979127 11.1325 -0.00635917 11.2295 0.0022583ZM10.5889 1.48175C8.53633 2.39367 6.72311 3.77061 5.29395 5.50323V13.3206C6.72311 15.0532 8.53633 16.4302 10.5889 17.3421V1.48175ZM15.5234 3.31573C15.6785 3.29853 15.8342 3.34326 15.9561 3.44073V3.44171C16.8507 4.15853 17.5731 5.06745 18.0693 6.10089C18.5655 7.13428 18.8232 8.26607 18.8232 9.41241C18.8232 10.5587 18.5655 11.6906 18.0693 12.7239C17.5731 13.7574 16.8507 14.6663 15.9561 15.3831C15.8342 15.4806 15.6785 15.5253 15.5234 15.5081C15.3684 15.4909 15.2264 15.4131 15.1289 15.2913C15.0315 15.1695 14.9867 15.0138 15.0039 14.8587C15.0212 14.7037 15.0989 14.5616 15.2207 14.4642C15.9783 13.858 16.5905 13.0896 17.0107 12.2151C17.431 11.3407 17.6484 10.3826 17.6484 9.41241C17.6484 8.4423 17.4309 7.4841 17.0107 6.60968C16.5905 5.73512 15.9783 4.96589 15.2207 4.35968C15.0989 4.26219 15.0211 4.12021 15.0039 3.96515C14.9867 3.81006 15.0314 3.65437 15.1289 3.53253C15.2264 3.41073 15.3684 3.33298 15.5234 3.31573ZM14.0537 5.1507C14.2088 5.13371 14.3646 5.17901 14.4863 5.27667C15.1056 5.77331 15.6057 6.40277 15.9492 7.11847C16.2927 7.8342 16.4707 8.61853 16.4707 9.41241C16.4706 10.2061 16.2926 10.9898 15.9492 11.7054C15.6057 12.4211 15.1056 13.0505 14.4863 13.5472C14.3646 13.6448 14.2088 13.6901 14.0537 13.6732C13.8986 13.6561 13.7568 13.578 13.6592 13.4564C13.5617 13.3348 13.5163 13.1797 13.5332 13.0247C13.5502 12.8696 13.6283 12.7269 13.75 12.6292C14.2318 12.2429 14.6204 11.7533 14.8877 11.1966C15.155 10.6398 15.2939 10.0301 15.2939 9.41241C15.2939 8.79463 15.1551 8.18419 14.8877 7.62726C14.6204 7.07058 14.2318 6.58089 13.75 6.19464C13.6283 6.09698 13.5502 5.95424 13.5332 5.79913C13.5163 5.64419 13.5616 5.48906 13.6592 5.36749C13.7568 5.24583 13.8986 5.1677 14.0537 5.1507ZM1.89062 5.88214C1.70143 5.8823 1.51952 5.95832 1.38574 6.0921C1.25214 6.22584 1.17693 6.40696 1.17676 6.59601V12.2278C1.17691 12.4169 1.25215 12.598 1.38574 12.7318C1.51952 12.8655 1.70143 12.9416 1.89062 12.9417H4.11816V5.88214H1.89062Z" fill="#004CC7"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                  <path d="M11.2295 0.00231934C11.3264 0.0109805 11.4197 0.0434796 11.501 0.0970459C11.5821 0.150668 11.6492 0.22328 11.6953 0.30896C11.7414 0.394671 11.7647 0.490944 11.7646 0.588257V18.2347C11.7646 18.3321 11.7405 18.4283 11.6943 18.514C11.6482 18.5995 11.582 18.6725 11.501 18.726C11.4198 18.7795 11.3263 18.812 11.2295 18.8207C11.1326 18.8293 11.0347 18.814 10.9453 18.7758L10.29 18.4945C8.02078 17.5176 6.01466 16.0176 4.43555 14.1176H1.89062C1.38951 14.1171 0.90903 13.9172 0.554688 13.5629C0.20041 13.2085 0.000467195 12.728 0 12.2269V6.59607C0.000467202 6.095 0.200401 5.61447 0.554688 5.26013C0.90903 4.90579 1.38951 4.70591 1.89062 4.70544H4.43555C6.01466 2.80538 8.02079 1.30542 10.29 0.328491L10.9453 0.0472412C11.0347 0.00889006 11.1326 -0.00629667 11.2295 0.00231934ZM10.5889 1.48181C8.5365 2.39366 6.72403 3.7699 5.29492 5.50232V13.3207C6.72403 15.0531 8.5365 16.4293 10.5889 17.3412V1.48181ZM1.89062 5.8822C1.70143 5.88236 1.51952 5.95741 1.38574 6.09119C1.25202 6.22496 1.17691 6.40692 1.17676 6.59607V12.2269C1.17691 12.4161 1.25203 12.598 1.38574 12.7318C1.51952 12.8656 1.70143 12.9406 1.89062 12.9408H4.11816V5.8822H1.89062ZM17.5479 7.15173C17.626 7.15105 17.7041 7.1661 17.7764 7.19568C17.8486 7.22525 17.9145 7.26939 17.9697 7.32458C18.0247 7.37962 18.0681 7.44502 18.0977 7.51697C18.1272 7.58926 18.1423 7.66738 18.1416 7.74548C18.1409 7.82345 18.1245 7.9004 18.0938 7.97205C18.0629 8.04381 18.0181 8.10919 17.9619 8.16345L16.7148 9.4115L17.9619 10.6595C18.0691 10.7705 18.1283 10.9194 18.127 11.0736C18.1256 11.2278 18.0641 11.3757 17.9551 11.4847C17.846 11.5937 17.6981 11.6553 17.5439 11.6566C17.3898 11.6579 17.2408 11.5987 17.1299 11.4916L15.8828 10.2435L14.6348 11.4916C14.5806 11.5476 14.516 11.5926 14.4443 11.6234C14.3726 11.6542 14.2949 11.6706 14.2168 11.6713C14.1388 11.6719 14.0615 11.6568 13.9893 11.6273C13.917 11.5977 13.8511 11.5536 13.7959 11.4984C13.7408 11.4433 13.6965 11.3781 13.667 11.306C13.6374 11.2337 13.6233 11.1556 13.624 11.0775C13.6247 10.9995 13.6411 10.9226 13.6719 10.851C13.7027 10.7792 13.7475 10.7138 13.8037 10.6595L15.0508 9.4115L13.8037 8.16345C13.7475 8.10919 13.7027 8.04381 13.6719 7.97205C13.6411 7.90036 13.6247 7.82349 13.624 7.74548C13.6233 7.66738 13.6374 7.58926 13.667 7.51697C13.6965 7.44486 13.7408 7.37971 13.7959 7.32458C13.8511 7.26935 13.917 7.22526 13.9893 7.19568C14.0615 7.16616 14.1388 7.15108 14.2168 7.15173C14.2949 7.15241 14.3726 7.16876 14.4443 7.19958C14.516 7.23038 14.5806 7.27537 14.6348 7.33142L15.8828 8.57947L17.1299 7.33142C17.1841 7.27524 17.2495 7.23041 17.3213 7.19958C17.3929 7.16884 17.4699 7.15247 17.5479 7.15173Z" fill="#DADADA"/>
                </svg>
              </div>
            </button>

            <!-- Right: Mic + Send -->
            <div class="ai-chat__right-actions">
              <button
                class="ai-chat__mic-btn"
                :class="{ 'ai-chat__mic-btn--active': isListening, 'ai-chat__mic-btn--inactive': toggleInactiveMic }"
                :disabled="isTyping"
                @click="toggleVoiceInput"
                aria-label="Voice input"
                :title="isListening ? 'Stop listening' : 'Start voice input'"
              >
                <svg v-if="!isListening && !toggleInactiveMic" xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
                  <path d="M13.125 10C13.2907 10 13.4502 10.0655 13.5674 10.1826C13.6846 10.2998 13.75 10.4592 13.75 10.625C13.7477 12.3392 13.1062 13.9911 11.9502 15.2568C10.7942 16.5225 9.20694 17.3105 7.5 17.4678V19.375C7.5 19.5408 7.43459 19.7002 7.31738 19.8174C7.20017 19.9346 7.04074 20 6.875 20C6.70946 19.9999 6.55072 19.9344 6.43359 19.8174C6.31638 19.7002 6.25 19.5408 6.25 19.375V17.4678C4.54328 17.3105 2.95672 16.5223 1.80078 15.2568C0.644756 13.9911 0.00226955 12.3392 0 10.625C6.04419e-06 10.4592 0.0663871 10.2998 0.183594 10.1826C0.300731 10.0657 0.45949 10 0.625 10C0.790724 10 0.950179 10.0655 1.06738 10.1826C1.18459 10.2998 1.24999 10.4592 1.25 10.625C1.25 12.1168 1.84263 13.5476 2.89746 14.6025C3.95231 15.6574 5.38322 16.2499 6.875 16.25C8.36681 16.25 9.79764 15.6574 10.8525 14.6025C11.9074 13.5476 12.5 12.1169 12.5 10.625C12.5 10.4592 12.5664 10.2998 12.6836 10.1826C12.8007 10.0657 12.9595 10.0001 13.125 10ZM6.875 0C8.03531 0 9.14827 0.460812 9.96875 1.28125C10.7892 2.10173 11.25 3.21466 11.25 4.375V10.625C11.2487 11.7847 10.7877 12.8966 9.96777 13.7168C9.14758 14.537 8.03493 14.9987 6.875 15C5.71514 14.9986 4.60335 14.5369 3.7832 13.7168C2.96308 12.8966 2.50132 11.7849 2.5 10.625V4.375C2.5 3.21472 2.96084 2.10172 3.78125 1.28125C4.60169 0.460813 5.71473 5.25315e-05 6.875 0ZM6.875 1.25C6.04626 1.25005 5.25105 1.57903 4.66504 2.16504C4.07906 2.75109 3.75 3.54624 3.75 4.375V10.625C3.75 11.4538 4.07906 12.2489 4.66504 12.835C5.25105 13.421 6.04626 13.7499 6.875 13.75C7.70378 13.75 8.49891 13.421 9.08496 12.835C9.67102 12.2489 10 11.4538 10 10.625V4.375C10 3.54619 9.67102 2.7511 9.08496 2.16504C8.49891 1.57903 7.70378 1.25 6.875 1.25Z" fill="#9CA3AF"/>
                </svg>
                <svg v-else width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.714286 6.78577C0.524845 6.78577 0.343164 6.86102 0.209209 6.99498C0.0752549 7.12893 0 7.31061 0 7.50005V12.5001C0 12.6895 0.0752549 12.8712 0.209209 13.0051C0.343164 13.1391 0.524845 13.2143 0.714286 13.2143C0.903726 13.2143 1.08541 13.1391 1.21936 13.0051C1.35332 12.8712 1.42857 12.6895 1.42857 12.5001V7.50005C1.42857 7.31061 1.35332 7.12893 1.21936 6.99498C1.08541 6.86102 0.903726 6.78577 0.714286 6.78577Z" fill="#E3E3E3"/>
                  <path d="M3.5714 2.5C3.38196 2.5 3.20028 2.57526 3.06633 2.70921C2.93237 2.84316 2.85712 3.02485 2.85712 3.21429V16.7857C2.85712 16.9752 2.93237 17.1568 3.06633 17.2908C3.20028 17.4247 3.38196 17.5 3.5714 17.5C3.76084 17.5 3.94252 17.4247 4.07648 17.2908C4.21043 17.1568 4.28569 16.9752 4.28569 16.7857V3.21429C4.28569 3.02485 4.21043 2.84316 4.07648 2.70921C3.94252 2.57526 3.76084 2.5 3.5714 2.5Z" fill="#E3E3E3"/>
                  <path d="M6.42852 4.64282C6.23908 4.64282 6.0574 4.71808 5.92344 4.85203C5.78949 4.98599 5.71423 5.16767 5.71423 5.35711V14.6428C5.71423 14.8323 5.78949 15.0139 5.92344 15.1479C6.0574 15.2819 6.23908 15.3571 6.42852 15.3571C6.61796 15.3571 6.79964 15.2819 6.9336 15.1479C7.06755 15.0139 7.1428 14.8323 7.1428 14.6428V5.35711C7.1428 5.16767 7.06755 4.98599 6.9336 4.85203C6.79964 4.71808 6.61796 4.64282 6.42852 4.64282Z" fill="#E3E3E3"/>
                  <path d="M9.28565 0C9.09621 0 8.91453 0.0752549 8.78057 0.209209C8.64662 0.343164 8.57137 0.524845 8.57137 0.714286V19.2857C8.57137 19.4752 8.64662 19.6568 8.78057 19.7908C8.91453 19.9247 9.09621 20 9.28565 20C9.47509 20 9.65677 19.9247 9.79073 19.7908C9.92468 19.6568 9.99994 19.4752 9.99994 19.2857V0.714286C9.99994 0.524845 9.92468 0.343164 9.79073 0.209209C9.65677 0.0752549 9.47509 0 9.28565 0Z" fill="#E3E3E3"/>
                  <path d="M12.1428 4.64282C11.9533 4.64282 11.7716 4.71808 11.6377 4.85203C11.5037 4.98599 11.4285 5.16767 11.4285 5.35711V14.6428C11.4285 14.8323 11.5037 15.0139 11.6377 15.1479C11.7716 15.2819 11.9533 15.3571 12.1428 15.3571C12.3322 15.3571 12.5139 15.2819 12.6478 15.1479C12.7818 15.0139 12.8571 14.8323 12.8571 14.6428V5.35711C12.8571 5.16767 12.7818 4.98599 12.6478 4.85203C12.5139 4.71808 12.3322 4.64282 12.1428 4.64282Z" fill="#E3E3E3"/>
                  <path d="M14.9999 2.5C14.8104 2.5 14.6288 2.57526 14.4948 2.70921C14.3609 2.84316 14.2856 3.02485 14.2856 3.21429V16.7857C14.2856 16.9752 14.3609 17.1568 14.4948 17.2908C14.6288 17.4247 14.8104 17.5 14.9999 17.5C15.1893 17.5 15.371 17.4247 15.505 17.2908C15.6389 17.1568 15.7142 16.9752 15.7142 16.7857V3.21429C15.7142 3.02485 15.6389 2.84316 15.505 2.70921C15.371 2.57526 15.1893 2.5 14.9999 2.5Z" fill="#E3E3E3"/>
                  <path d="M17.857 6.78577C17.6676 6.78577 17.4859 6.86102 17.3519 6.99498C17.218 7.12893 17.1427 7.31061 17.1427 7.50005V12.5001C17.1427 12.6895 17.218 12.8712 17.3519 13.0051C17.4859 13.1391 17.6676 13.2143 17.857 13.2143C18.0464 13.2143 18.2281 13.1391 18.3621 13.0051C18.496 12.8712 18.5713 12.6895 18.5713 12.5001V7.50005C18.5713 7.31061 18.496 7.12893 18.3621 6.99498C18.2281 6.86102 18.0464 6.78577 17.857 6.78577Z" fill="#E3E3E3"/>
                </svg>
              </button>

              <button
                id="ai-chat__send"
                class="ai-chat__send-btn"
                :disabled="!draft || isTyping"
                @click="handleEnter"
                aria-label="Send message"
                title="Send (Enter)"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                  <path d="M6.375 0.0169678C6.4983 -0.00568226 6.62478 -0.00564277 6.74805 0.0169678H6.8291L6.93848 0.0540771L7.09961 0.141968C7.1525 0.175636 7.20165 0.214951 7.24609 0.259155L12.8398 5.85974C12.8417 5.86156 12.8439 5.86378 12.8457 5.8656C13.2185 6.24167 13.2158 6.84908 12.8398 7.22205C12.4599 7.58805 11.8585 7.58798 11.4785 7.22205L8.14648 3.88318C8.07933 3.8174 7.98949 3.78002 7.89551 3.77869C7.69354 3.77593 7.52743 3.93709 7.52441 4.13904V15.0414C7.52433 15.5711 7.09509 16.0003 6.56543 16.0004C6.03576 16.0003 5.6065 15.571 5.60645 15.0414V4.13904C5.60507 4.04513 5.56767 3.95514 5.50195 3.88806C5.36048 3.74374 5.12874 3.74184 4.98438 3.88318L1.6377 7.22205C1.2586 7.58343 0.662177 7.58358 0.283203 7.22205C0.281417 7.22026 0.280074 7.21797 0.27832 7.21619C-0.0947306 6.84015 -0.0928178 6.2328 0.283203 5.85974L5.89941 0.222046C5.95631 0.167526 6.0206 0.120994 6.08984 0.083374L6.21387 0.0169678H6.375Z" fill="white"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </footer>

      <!-- Footer links / disclaimer -->
      <div class="ai-chat__footer-info">
        <p class="ai-chat__disclaimer">
          AI responses may not be fully accurate. Always verify details before purchase.
        </p>
        <div class="ai-chat__footer-actions">
          <!-- Insubuy-only debug buttons -->
          <button
            v-if="isInsubuy && isInternal"
            @click="clearSessionAndConversations"
            class="ai-chat__debug-btn"
            title="Clear session and start over"
            aria-label="Clear session"
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="ai-chat__debug-btn-text">Clear</span>
          </button>
          <button
            v-if="isInsubuy && sessionId && isInternal"
            @click="copySessionId"
            class="ai-chat__debug-btn"
            title="Copy session ID"
            aria-label="Copy session ID"
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="ai-chat__debug-btn-text">Copy ID</span>
          </button>

          <button type="button" @click="showInsuranceModal = true" class="ai-chat__alt">
            Skip the chat and use the quote form.
          </button>
        </div>
      </div>
    </div>

    <!-- Insurance Sections Modal -->
    <transition name="ai-chat__modal-fade">
      <div v-if="showInsuranceModal" class="ai-chat__modal-overlay" @click="showInsuranceModal = false">
        <div class="ai-chat__modal-container" @click.stop>
          <!-- Close Button -->
          <button @click="showInsuranceModal = false" class="ai-chat__modal-close" aria-label="Close modal">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="currentColor">
              <path d="M1.85177 36C1.37718 36 0.903747 35.8194 0.542596 35.4571C-0.180865 34.7336 -0.180865 33.561 0.542596 32.8375L32.8379 0.542609C33.5614 -0.18087 34.7339 -0.18087 35.4574 0.542609C36.1809 1.26609 36.1809 2.4387 35.4574 3.16218L3.16326 35.4571C2.79979 35.8183 2.32636 36 1.85177 36ZM34.1482 36C33.6736 36 33.2002 35.8194 32.8391 35.4571L0.543753 3.16218C-0.179708 2.4387 -0.179708 1.26493 0.543753 0.542609C1.26721 -0.179712 2.4398 -0.18087 3.16326 0.542609L35.4574 32.8375C36.1809 33.561 36.1809 34.7336 35.4574 35.4571C35.0939 35.8183 34.6205 36 34.1494 36H34.1482Z"/>
            </svg>
          </button>

          <!-- Modal Content -->
          <div class="ai-chat__modal-content">
            <!-- Heading -->
            <div class="ai-chat__modal-heading">
              <h2 class="ai-chat__modal-title">Selecting Your Coverage Location</h2>
              <p class="ai-chat__modal-description">Select the insurance section that best matches your needs:</p>
            </div>

            <!-- Insurance Grid -->
            <div class="ai-chat__insurance-grid">
              <a
                v-for="section in insuranceSections"
                :key="section.href"
                :href="section.href"
                class="ai-chat__insurance-card"
              >
                <div class="ai-chat__insurance-info">
                  <h3 class="ai-chat__insurance-title">{{ section.title }}</h3>
                  <p class="ai-chat__insurance-description">{{ section.description }}</p>
                </div>

                <!-- Arrow -->
                <div class="ai-chat__insurance-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="24" viewBox="0 0 13 24" fill="#004CC7">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.436 11.6379L0.237948 21.8722C-0.0727328 22.1881 -0.0804998 22.7014 0.222414 23.0172C0.222414 23.0172 0.222414 23.0251 0.237948 23.033C0.556395 23.3568 1.07678 23.3568 1.39523 23.033L12.1758 12.2144C12.4865 11.8985 12.4943 11.3852 12.1914 11.0694L12.1758 11.0536L1.39523 0.242827C1.07678 -0.0809424 0.556395 -0.0809424 0.237948 0.242827C-0.0727328 0.5587 -0.0804998 1.07199 0.222414 1.38787C0.222414 1.38787 0.222414 1.38787 0.237948 1.40366L10.436 11.6379Z" fill="#004CC7"/>
                  </svg>
                </div>

                <!-- Icon (background, uses mask-image) -->
                <div class="ai-chat__insurance-icon" :class="'ai-chat__insurance-icon--' + section.iconType"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Conversation feedback modal (opened from the CSAT star row) -->
    <transition name="ai-chat__modal-fade">
      <ai-chat-csat-modal
        v-if="csatModalOpen"
        :initial-rating="csatRating"
        @submit="submitCsat"
        @close="closeCsatModal"
      />
    </transition>

    <!-- Share Quotes Modal -->
    <transition name="modal-fade">
      <save-share
        v-if="saveShareShown"
        :show-modal="saveShareShown"
        :type="'quote'"
        :id="shareQuoteId"
        :url="shareQuoteLink"
        :is-logged-in="isLoggedIn"
        @toggle-save-share="closeShareModal"
        @request-login-modal="requestLoginModal"
        :quote-type="quoteType"
      />

      <div v-if="showCompareStyles">
        <compare-plans />
      </div>
    </transition>

    <div v-if="showCompareStyles">
      <compare-plans />
    </div>

    <!-- Login Modal (rendered here so it is never trapped inside a hidden save-share) -->
    <transition name="modal-fade">
      <component :is="loginModalLoadMouseoutComponent" v-if="showLoginModalComponent" />
    </transition>
  </div>
</template>

<script>

import StreamingMessage from './component.streaming-message.vue';
import { LoginModalMixin } from '../section-specific/applications/mixins/loginModal';
import { marked, Renderer } from 'marked';
import DOMPurify from 'dompurify';

// Configure marked for better rendering
marked.setOptions({
  breaks: true,
  gfm: true,
  headerIds: false,
  mangle: false
});

// Custom renderer to open links in new tab
const renderer = new Renderer();
renderer.link = function(href, title, text) {
  const isAiAction = typeof href === 'string' && (href.indexOf('ai-action:') === 0 || href.indexOf('#ai-action:') === 0);
  const titleAttr = title ? ` title="${title}"` : '';
  if (isAiAction) {
    return `<a href="${href}"${titleAttr}>${text}</a>`;
  }
  return `<a href="${href}"${titleAttr} target="_blank" rel="noopener noreferrer">${text}</a>`;
};
marked.use({ renderer });

export default {
  name: 'AiChat',
  mixins: [LoginModalMixin],
  props: {
    title: { type: String, default: 'AI Quote Assistant' },
    subtitle: {
      type: String,
      default:
        `Tell us your trip details (dates, travelers' ages, destination)...`
    },
    placeholder: { type: String, default: "Type your message…" },
    welcome: {
      type: String,
      default:
        "Welcome to Insubuy! I'm your AI assistant. Tell me your destination, travel dates, and travelers' ages to get started."
    },
    agentName: { type: String, default: 'Assistant' },
    userName: { type: String, default: 'You' },
    alternateLinkHref: { type: String, default: '/get-travel-insurance-quotes/' },
    disclaimer: {
      type: String,
      default:
        'The AI Quote Assistant may not be fully accurate; please verify all information before purchasing. Listed plan features are summaries for your convenience. Read the Policy Brochure and Plan Details for complete and accurate details.'
    },
    apiUrl: { type: String, default: '/cognix/question' }, 
    authToken: { type: String, default: '' }
  },
  components: {
    'streaming-message': StreamingMessage,
    'plan-blocks': () => import('./component.plan-blocks.vue'),
    'save-share': () => import('./forms/component.save-share.vue'),
    'compare-plans': () => import('./component.ai-compare-styles.vue'),
    // Lazy chunk — only fetched when the CSAT prompt is first shown.
    'ai-chat-csat': () => import('./component.ai-chat-csat.vue'),
    // Lazy chunk — only fetched when a star is picked on the CSAT card.
    'ai-chat-csat-modal': () => import('./component.ai-chat-csat-modal.vue')
  },
  data() {
    return {
      messages: [],
      draft: '',
      isTyping: false,
      error: '',
      sessionId: '',
      userHasScrolledUp: false,
      scrollObserver: null,
      sessionExpired: false,
      showInsuranceModal: false,
      // Named to match quote-results-base-v2 so the shared login-modal mixin
      // (loginModal.js closeModal) can hide/restore this modal around itself.
      saveShareShown: false,
      loginModalFromSaveShare: false,
      shareQuoteLink: '',
      quoteType: '',
      inputFocused: false,
      isComposerLarge: false,
      // Ordered by prompt volume and intent (YTD 2026 Scout prompt analysis).
      faqSuggestions: [
        "Is COVID covered?",
        'Are pre-existing conditions covered? (and what is "acute onset"?)',
        "Compare Patriot America Plus, Atlas America, and Safe Travels USA",
        "What is the difference between comprehensive and fixed coverage plans?",
        "Which plan is best for travelers over age 70?",
        "Can I still buy if the traveler is already in the US?",
        "I already have a policy (claims, changes, documents)"
      ],
      faqCards: [
        {
          title: "Help me pick a plan for my trip (age, dates, visa)",
          description: "Get personalized recommendations in under a minute.",
          icon: "plan-picker"
        },
        {
          title: "Which plan meets my visa requirements?",
          description: "See which plans satisfy J, F, Schengen, and more.",
          icon: "visa-requirements"
        },
        {
          title: "What does visitor medical insurance cover?",
          description: "A plain-language look at what's covered — and what isn't.",
          icon: "coverage"
        }
      ],
      insuranceSections: [
        {
          title: 'USA Visitors Insurance',
          href: 'https://www.insubuy.com/visitors-insurance/',
          iconType: 'usa-visitors',
          description: 'Medical coverage for visitors to the USA'
        },
        {
          title: 'Travel Outside USA',
          href: 'https://www.insubuy.com/travel-health-insurance/',
          iconType: 'outside-usa',
          description: 'Protection for international traveler'
        },
        {
          title: 'Travel Insurance',
          href: 'https://www.insubuy.com/travel-insurance/',
          iconType: 'trip',
          description: 'Trip cancellation coverage for US residents'
        },
        {
          title: 'International Student Insurance',
          href: 'https://www.insubuy.com/student-coverage/?presection=international-student',
          iconType: 'f-visa',
          description: 'Medical coverage for study in the USA on an F or M visa'
        },
        {
          title: 'Exchange Visitor Insurance',
          href: 'https://www.insubuy.com/student-coverage/?presection=exchange-visitor',
          iconType: 'j-visa',
          description: 'Medical coverage for J visa exchange programs'
        },
        {
          title: 'OPT Insurance',
          href: 'https://www.insubuy.com/student-coverage/?presection=opt',
          iconType: 'opt',
          description: 'Medical coverage for Optional Practical Training'
        }
      ],
      loadingMessages: [
        'Finding the best insurance options for you...',
        'Analyzing your travel requirements...',
        'Insurance prices are regulated by law — you\'re guaranteed the best price',
        'Comparing plans from trusted providers...',
        'Insubuy provides unbiased insurance recommendations',
        'Searching our comprehensive database...',
        'Getting personalized plan suggestions...',
        'Reviewing coverage options that match your needs...'
      ],
      currentLoadingMessageIndex: 0,
      loadingMessageInterval: null,
      // Voice features
      isListening: false,
      isSpeaking: false,
      voiceEnabled: false,
      recognition: null,
      speechSynthesis: null,
      currentUtterance: null,
      voiceTranscript: '', // Temporary storage for voice input
      voiceInputUsed: false, // Track if user has used voice input
      criteria: null,
      section: null,
      isInternal: window.globalLanguage.internalIP,
      toggleInactiveSpk: false,
      toggleInactiveMic: false,
      showCompareStyles: false,
      // Conversation-level CSAT (once per session)
      showCsat: false,
      csatDone: false,
      csatRating: 0,
      csatSubmitted: false,
      csatModalOpen: false,
      // GTM/META intent tracking (once per session for chat_initiated).
      // Counts only typed questions the backend classified as real (intent > 0);
      // default/suggested questions never count.
      chatAttempts: 0,
      chatInitiatedFired: false,
      // Set just before a default/suggested question is sent so it can be
      // excluded from intent tracking.
      nextSendIsDefault: false
    };
  },
  computed: {
    currentLoadingMessage() {
      return this.loadingMessages[this.currentLoadingMessageIndex];
    },
    isInsubuy() {
      // Check if we're on Insubuy (not CTS)
      return !window.ctsJS;
    },
    hasMessages() {
      return this.messages?.length > 0;
    },
    showWelcomeScreen() {
      return this.isInsubuy ? !this.hasMessages : false;
    },
    showFaqSuggestions() {
      // Show dropdown when focused, no messages, and there are matching FAQs
      return !this.hasMessages && this.inputFocused && this.filteredFaqSuggestions.length > 0;
    },
    filteredFaqSuggestions() {
      // If input is empty, show all suggestions
      if (!this.draft || this.draft.trim() === '') {
        return this.faqSuggestions;
      }

      // Filter suggestions that match the input (case insensitive)
      const searchTerm = this.draft.toLowerCase();
      return this.faqSuggestions.filter(suggestion =>
        suggestion.toLowerCase().includes(searchTerm)
      );
    },
    /**
     * Extract the quote ID from the shareQuoteLink URL
     */
    shareQuoteId() {
      if (!this.shareQuoteLink) return '';
      try {
        const url = new URL(`https://www.insubuy.com${this.shareQuoteLink}`);
        return url.searchParams.get('id') || '';
      } catch (e) {
        // Fallback for relative URLs or malformed URLs
        const match = this.shareQuoteLink.match(/[?&]id=([^&]+)/);
        return match ? match[1] : '';
      }
    },
    /**
     * Check if user is logged in
     */
    isLoggedIn() {
      return window.ibJS?.UserLoggedInMyAcoount ? true : false;
    }
  },
  watch: {
    isTyping(newVal) {
      if (newVal) {
        // Start rotating loading messages
        this.currentLoadingMessageIndex = 0;
        this.loadingMessageInterval = setInterval(() => {
          this.currentLoadingMessageIndex =
            (this.currentLoadingMessageIndex + 1) % this.loadingMessages.length;
        }, 2500); // Rotate every 2.5 seconds
      } else {
        // Stop rotating when typing ends
        if (this.loadingMessageInterval) {
          clearInterval(this.loadingMessageInterval);
          this.loadingMessageInterval = null;
        }
      }
    },
    draft() {
      // Check if textarea needs to expand (multiple lines or more text)
      this.$nextTick(() => {
        this.checkComposerSize();
      });
    },
    section (sect) {
      if (sect) {
        this.quoteType = ['visitorUSA','travelOutsideUSA','schengen','newImmigrants','studyAbroad','missionaryTravel', "covid19"].indexOf(sect) > -1 ? 'travelmedical' : '';
      }
    },
    // Single place that owns the body scroll lock for the save/share modal, so it
    // stays correct when the login modal temporarily takes the modal's place.
    saveShareShown (val) {
      document.body.style.overflow = val ? 'hidden' : '';
    },
    // The coverage-location modal let the page scroll behind it. Uses the same
    // is-Locked--quote class as the AI Compare modal on this page — plain
    // is-Locked is non-important and gets overridden here. (AIQ-176)
    showInsuranceModal (val) {
      document.body.classList.toggle('is-Locked--quote', !!val);
    }
  },
  mounted() {
    // Try to restore previous session from sessionStorage
    this.restoreSession();

    // Note: We no longer show an automatic welcome message
    // Instead, the welcome screen will be displayed when there are no messages

    this.$nextTick(this.scrollToBottom);

    // Setup scroll detection on window
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    // Initialize voice features
    this.initVoiceFeatures();

    // Initialize logo animation
    this.initLogoAnimation();
  },
  beforeDestroy() {
    // Remove window scroll listener
    window.removeEventListener('scroll', this.handleScroll);

    // Clean up loading message interval
    if (this.loadingMessageInterval) {
      clearInterval(this.loadingMessageInterval);
    }

    if (this.saveShareShown) {
      document.body.style.overflow = '';
    }

    if (this.showInsuranceModal) {
      document.body.classList.remove('is-Locked--quote');
    }

    // Clean up voice features
    this.stopListening();
    this.stopSpeaking();

    // Clean up any pending feedback timers
    this.clearCsatTimers();
  },
  methods: {
    /**
     * Hide the save/share modal while the login modal is up — the login modal
     * (z-index 9999) renders under .c-Modal, so both cannot be shown at once.
     * loginModal.js closeModal() restores saveShareShown when it is dismissed.
     */
    requestLoginModal(type = '') {
      if (this.saveShareShown) {
        this.saveShareShown = false;
        this.loginModalFromSaveShare = true;
      }
      LoginModalMixin.methods.requestLoginModal.call(this, type);
    },
    handleAiChatActionClick(event) {
      const link = event && event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;

      const href = (link.getAttribute('href') || '').trim();

      if (href === 'ai-action:live-chat' || href === '#ai-action:live-chat') {
        event.preventDefault();
        this.openLiveAgentChat();
      } else if (href === 'ai-action:schedule-callback' || href === '#ai-action:schedule-callback') {
        event.preventDefault();
        this.openCallbackModal();
      }
    },
    openLiveAgentChat() {
      const genesysApp = document.querySelector('.genesys-app');
      if (genesysApp) {
        genesysApp.style.visibility = 'visible';
      }

      const genesysFn = (typeof window !== 'undefined' && typeof window.Genesys === 'function')
        ? window.Genesys
        : null;

      if (genesysFn) {
        genesysFn('command', 'Messenger.open', {},
          function() {},
          function() {
            genesysFn('command', 'Messenger.close');
          }
        );
      }
    },
    openCallbackModal() {
      if (window.GlobalVue && typeof window.GlobalVue.showGoAwayModal === 'function') {
        window.GlobalVue.showGoAwayModal();
      }
    },
    getCallbackSupportMessage() {
      const isOfficeOpen = !!(window.GlobalVue && window.GlobalVue.isOfficeOpen);
      const officeHours = (window.GlobalVue && window.GlobalVue.allSevenDays) ? window.GlobalVue.allSevenDays : 'Mon-Fri, 8 AM - 7 PM CST';

      if (isOfficeOpen) {
        return "I'd be happy to get you to the right person! Our live agents are currently available to assist you. You can connect with us in the following ways:\n\n- Chat Live: [Click here](#ai-action:live-chat) to start a live chat with an agent.\n- Call Us: [Dial our toll-free number at +1 (866) 467-8289](tel:+18664678289).\n- Schedule a Call: If you're in a rush, [click here](#ai-action:schedule-callback) to schedule a callback and we'll reach out to you.";
      }

      return `Our live support agents are currently offline, but we want to make sure you get the help you need! Our standard office hours are ${officeHours}.\n\nIn the meantime, you can:\n- Schedule a Callback: [Click here](#ai-action:schedule-callback) to pick a time during our office hours, and an agent will call you back.\n- Leave a Message: Feel free to describe your request here, and I will do my best to find the answer for you in our knowledge base.`;
    },
    /**
     * Open the share quotes modal
     */
    openShareModal({ quoteLink, quoteId, selections }) {
      this.requestCsatFromCta(); // high-intent action
      // GTM's save_share_block tag reads the quote id from ibJS.fullQuoteId, as on quote results.
      // Set synchronously so it is in place before the click bubbles to GTM's listener.
      if (window.ibJS && quoteId) window.ibJS.fullQuoteId = quoteId;
      this.shareQuoteLink = `${window.location.origin}${quoteLink}`;
      this.saveShareShown = true;
      this.saveQuoteSelections(quoteId, selections);
    },
    saveQuoteSelections(quoteId, selections) {
      if (!quoteId || !selections || !window.ibJS || !window.ibJS.saveNarrowQuoteAPIPath) return;
      this.$http.post(window.ibJS.saveNarrowQuoteAPIPath, { id: quoteId, quoteDeductibles: selections });
    },
    handleViewAllResults({ quoteLink, quoteId, selections }) {
      this.requestCsatFromCta(); // high-intent action
      // GA4 (via GTM dataLayer). Wrapped so analytics can never break the chat.
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'ai_view_all_results',
          quote_id: quoteId || null,
          uuid: window.usun || null,
          session_id: this.sessionId || null
        });
      } catch (e) { /* analytics must never break the chat */ }
      // tid=scout marks the arrival as a Scout forward journey, not a returning customer resuming a saved quote.
      const scoutLink = `${quoteLink}${quoteLink.indexOf('?') > -1 ? '&' : '?'}tid=scout`;
      const open = () => window.open(scoutLink, '_blank');
      if (!quoteId || !selections || !window.ibJS || !window.ibJS.saveNarrowQuoteAPIPath) {
        open();
        return;
      }
      this.$http.post(window.ibJS.saveNarrowQuoteAPIPath, { id: quoteId, quoteDeductibles: selections }).then(open, open);
    },
    /**
     * Close the share quotes modal
     */
    closeShareModal() {
      this.saveShareShown = false;
      this.loginModalFromSaveShare = false;
      this.shareQuoteLink = '';
    },
    /**
     * Check if the composer should be in large mode (multiline or long text)
     */
    checkComposerSize() {
      const textarea = this.$refs.txtinput;
      if (!textarea) return;

      const hasNewlines = this.draft.includes('\n');
      const draftLength = this.draft.length;

      // If already in large mode, only exit when content is clearly small
      if (this.isComposerLarge) {
        // Stay in large mode unless content is empty or very short with no newlines
        if (!hasNewlines && draftLength < 30) {
          this.isComposerLarge = false;
          textarea.style.height = '';
        } else {
          // Adjust height while staying in large mode
          textarea.style.height = 'auto';
          const scrollHeight = textarea.scrollHeight;
          textarea.style.height = Math.min(scrollHeight, 135) + 'px';
        }
      } else {
        // Not in large mode - check if we need to enter it
        textarea.style.height = 'auto';
        const scrollHeight = textarea.scrollHeight;
        const exceedsLineHeight = scrollHeight > 50;

        if (hasNewlines || exceedsLineHeight) {
          this.isComposerLarge = true;
          textarea.style.height = Math.min(scrollHeight, 135) + 'px';
        } else {
          textarea.style.height = '';
        }
      }
    },
    saveSession() {
      try {
        const sessionData = {
          messages: this.messages,
          sessionId: this.sessionId,
          sessionExpired: this.sessionExpired,
          uuid: window.usun || '',
          userName: localStorage.getItem('cts_username') || null,
          timestamp: Date.now(),
          criteria: this.criteria,
          section: this.section,
          csatDone: this.csatDone,
          chatAttempts: this.chatAttempts,
          chatInitiatedFired: this.chatInitiatedFired
        };
        sessionStorage.setItem('aiChatSession', JSON.stringify(sessionData));
      } catch (e) {
        console.error('Failed to save session:', e);
      }
    },
    restoreSession() {
      try {
        const savedData = sessionStorage.getItem('aiChatSession');
        if (!savedData) return false;

        const sessionData = JSON.parse(savedData);

        // Check if session is not too old (optional: expire after 1 hour)
        const ONE_HOUR = 60 * 60 * 1000;
        if (Date.now() - sessionData.timestamp > ONE_HOUR) {
          sessionStorage.removeItem('aiChatSession');
          return false;
        }

        // Restore session state
        this.messages = (sessionData.messages || []).map(msg => {
          // Mark all restored assistant messages to skip streaming effect
          // Always set to true for restored messages, regardless of previous value
          if (msg.role === 'assistant') {
            msg.skipStreaming = true;
          }
          return msg;
        });
        this.criteria = sessionData.criteria || null;
        this.section = sessionData.section || null;
        this.sessionId = sessionData.sessionId || '';
        if (!window.usun && sessionData.uuid) {
          window.usun = sessionData.uuid;
        }
        this.sessionExpired = sessionData.sessionExpired || false;
        this.csatDone = sessionData.csatDone || false;
        this.chatAttempts = sessionData.chatAttempts || 0;
        this.chatInitiatedFired = sessionData.chatInitiatedFired || false;

        // Check if last message was from user with no response
        this.checkForIncompleteConversation();

        // Returning to a conversation — start the idle fallback so feedback can
        // still be requested if they go quiet (value-moment triggers also apply
        // as soon as they continue the conversation).
        this.$nextTick(() => this.resetCsatIdleTimer());

        return true;
      } catch (e) {
        console.error('Failed to restore session:', e);
        sessionStorage.removeItem('aiChatSession');
        return false;
      }
    },
    checkForIncompleteConversation() {
      if (this.messages.length === 0) return;

      const lastMessage = this.messages[this.messages.length - 1];

      // If last message is from user and there's no typing indicator, mark it for retry
      if (lastMessage.role === 'user' && !this.isTyping) {
        // Add retry flag to the message
        this.$set(lastMessage, 'needsRetry', true);
      }
    },
    clearSession() {
      try {
        sessionStorage.removeItem('aiChatSession');
      } catch (e) {
        console.error('Failed to clear session:', e);
      }
    },
    formatText(txt) {
      if (!txt) return '';

      // Fix malformed markdown links with nested links inside URL
      // Pattern: [text](https://domain.com[Link Text](/path/)) -> [text](https://domain.com/path/)
      let fixedTxt = txt.replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s\[]+)\[[^\]]*\]\(([^)]+)\)\)/g,
        '[$1]($2$3)'
      );

      // Also fix pattern where the URL has a nested markdown link without proper closure
      // Pattern: [text](https://domain.com[Link Text](/path/) -> [text](https://domain.com/path/)
      fixedTxt = fixedTxt.replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s\[]+)\[[^\]]*\]\(([^)]+)\)/g,
        '[$1]($2$3)'
      );

      // Parse markdown and sanitize HTML
      const html = marked.parse(fixedTxt);
      return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'code', 'pre', 'a', 'ul', 'ol', 'li', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
        ALLOWED_ATTR: ['href', 'target', 'rel', 'class']
      });
    },
    // Normalize a plan display name for tolerant matching (strips HTML tags, entities, symbols)
    normalizePlanName(value) {
      return String(value || '')
        .replace(/<[^>]+>/g, ' ')
        .replace(/&[a-z0-9#]+;/gi, ' ')
        .replace(/[^a-z0-9\s]/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    },
    // Render an assistant message with compare-table enhancements:
    //   • {{PURCHASE:planName}} tokens → price + purchase button
    //   • Yes/No table cells → icon spans
    //   • <table> wrapped in c-AICompare__table-wrap
    formatAssistantHtml (message) {
      if (!message || !message.text) return '';
      const plans = message.plans || [];
      const vm = this;

      // Lazy-load the compare CSS bundle — only for responses that carry {{PURCHASE:}} tokens
      const hasCompareTokens = /\{\{PURCHASE:/i.test(message.text);
      if (hasCompareTokens) {
        this.showCompareStyles = true;
      }

      // Same link fixup as formatText
      let fixedTxt = message.text.replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s\[]+)\[[^\]]*\]\(([^)]+)\)\)/g,
        '[$1]($2$3)'
      );
      fixedTxt = fixedTxt.replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s\[]+)\[[^\]]*\]\(([^)]+)\)/g,
        '[$1]($2$3)'
      );

      // The purchase token can carry a "|" before its link, which collides with
      // the markdown table column delimiter and breaks the whole table. Swap those
      // pipes for a private sentinel BEFORE parsing, then split on it below.
      const PURCHASE_PIPE = String.fromCharCode(0xE000);
      fixedTxt = fixedTxt.replace(/\{\{PURCHASE:[^}]*\}\}/g, function (t) {
        return t.replace(/\|/g, PURCHASE_PIPE);
      });

      let html = marked.parse(fixedTxt);

      // Replace {{PURCHASE:planName}} tokens with price + button
      const normPlan = this.normalizePlanName.bind(this);
      html = html.replace(/\{\{PURCHASE:([^}]+)\}\}/g, function(_, rawName) {
        // Token may carry an optional link after the sentinel: {{PURCHASE:Name<sep>/path/}}.
        const raw = String(rawName);
        const pipe = raw.indexOf(PURCHASE_PIPE);
        const name = (pipe >= 0 ? raw.slice(0, pipe) : raw).trim();
        const tokenLink = pipe >= 0 ? raw.slice(pipe + 1).trim() : '';
        const safeName = name.replace(/"/g, '&quot;');
        const normalized = normPlan(name);

        const match = plans.find(function(p) {
          const cfg = p.planDetails && p.planDetails.config;
          const displayName = (cfg && (cfg.displayNameWSym || cfg.displayName)) || '';
          const clean = normPlan(displayName);
          return !!clean && !!normalized && (
            clean === normalized ||
            clean.indexOf(normalized) === 0 ||
            normalized.indexOf(clean) === 0
          );
        });

        let priceHtml = '';
        if (match) {
          // Try the simplest price fields first, then fall back to travelerPrices
          let priceNum = null;
          if (match.defaultTotalPrice != null) {
            priceNum = parseFloat(match.defaultTotalPrice);
          } else if (match.planDetails && match.planDetails.price != null) {
            priceNum = parseFloat(match.planDetails.price);
          } else if (match.travelerPrices && match.travelerPrices[0] && match.travelerPrices[0].itemPrices && match.travelerPrices[0].itemPrices[0]) {
            priceNum = parseFloat(match.travelerPrices[0].itemPrices[0].price);
          }
          if (priceNum != null && !isNaN(priceNum)) {
            const priceStr = priceNum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            priceHtml = '<span class="c-AICompare__th-price">$' + priceStr + ' USD</span>';
          }
        }

        // Prefer the link from the token; fall back to the matched plan's link.
        // If neither exists the attribute is empty and the button stays inert.
        const purchaseLink = tokenLink || (match && match.planDetails && match.planDetails.purchaseLink) || '';
        const safeLink = purchaseLink.replace(/"/g, '&quot;');
        return priceHtml + '<button type="button" class="o-Btn o-Btn--prim c-AICompare__th-btn" data-ai-purchase="' + safeName + '" data-ai-purchase-link="' + safeLink + '">Purchase</button>';
      });

      // Wrap Yes/No in icon spans.
      // (<td[^>]*>) captures any attributes marked adds (align="center", style=…).
      // Trailing text after "Yes" (e.g. " (acute onset only)") is kept as a raw
      // text node outside the span — CSS makes .ai-yes display:block so the text
      // naturally stacks below the icon in both table and card contexts.
      html = html.replace(/(<td[^>]*>)\s*Yes\b([^<]*)<\/td>/gi, function(_, tdOpen, trailing) {
        return tdOpen + '<span class="ai-yes">Yes</span>' + trailing.trim() + '</td>';
      });
      html = html.replace(/(<td[^>]*>)\s*No\s*<\/td>/gi, '$1<span class="ai-no">No</span></td>');

      // Wrap tables and generate sibling mobile-card blocks — only for compare responses
      if (!hasCompareTokens) return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'code', 'pre', 'a', 'ul', 'ol', 'li', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'div', 'span', 'button'],
        ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'type', 'data-ai-purchase', 'data-ai-purchase-link']
      });

      // Resolve a plan's own brand color from its display name so the chat table
      // and cards match the plan blocks shown elsewhere.
      // Keep the fallback order explicit: a color returned for the compare
      // result wins, then the quote plan metadata, then the visual fallback
      // palette used by the compare table/card design.
      var compareFallbackColors = ['#035184', '#2b9390', '#c67e00'];
      var colorForPlan = function (planName, planIndex) {
        var n = normPlan(planName);
        var m = plans.find(function (p) {
          var cfg = p.planDetails && p.planDetails.config;
          var dn = (p && (p.planName || p.displayName)) || (cfg && (cfg.displayNameWSym || cfg.displayName)) || '';
          var clean = normPlan(dn);
          return !!clean && !!n && (clean === n || clean.indexOf(n) === 0 || n.indexOf(clean) === 0);
        });

        // Some compare responses expose planColor directly on the plan item.
        var compareColor = m && m.planColor;
        if (compareColor) return compareColor;

        // Normal quote responses keep it in planDetails.config.
        var planDetailsColor = m && m.planDetails && m.planDetails.config && m.planDetails.config.planColor;
        if (planDetailsColor) return planDetailsColor;

        // A compare response may contain only markdown. Re-use the plans from
        // the earlier quote message in the same conversation.
        var previousPlan;
        for (var i = vm.messages.length - 1; i >= 0; i--) {
          var message = vm.messages[i];
          if (!message.plans || !message.plans.length) continue;
          previousPlan = message.plans.find(function (p) {
            var cfg = p.planDetails && p.planDetails.config;
            var dn = (p && (p.planName || p.displayName)) || (cfg && (cfg.displayNameWSym || cfg.displayName)) || '';
            var clean = normPlan(dn);
            return !!clean && !!n && (clean === n || clean.indexOf(n) === 0 || n.indexOf(clean) === 0);
          });
          if (previousPlan) break;
        }
        var previousColor = previousPlan && previousPlan.planColor;
        if (!previousColor) {
          previousColor = previousPlan && previousPlan.planDetails && previousPlan.planDetails.config && previousPlan.planDetails.config.planColor;
        }
        return previousColor || compareFallbackColors[planIndex] || compareFallbackColors[0];
      };

      html = html.replace(/<table[\s\S]*?<\/table>/gi, function (tableHtml) {
        // Build mobile cards from the already-transformed table HTML
        var cardsHtml = '';
        try {
          var doc = (new DOMParser()).parseFromString(tableHtml, 'text/html');
          var headerThs = [].slice.call(doc.querySelectorAll('thead th'), 1); // skip "Benefit" col
          var bodyRows  = [].slice.call(doc.querySelectorAll('tbody tr'));

          if (headerThs.length && bodyRows.length) {
            cardsHtml = '<div class="c-AICompare__cards">';
            headerThs.forEach(function (th, i) {
              // Purchase link lives on the button already injected into the th
              var purchaseBtn  = th.querySelector('[data-ai-purchase-link]');
              var purchaseLink = purchaseBtn ? (purchaseBtn.getAttribute('data-ai-purchase-link') || '') : '';
              var safeLink     = purchaseLink.replace(/"/g, '&quot;');

              // Plan name: clone th, strip price span + button, read remaining text
              var clone = th.cloneNode(true);
              [].forEach.call(clone.querySelectorAll('button, .c-AICompare__th-price'), function (el) {
                el.parentNode.removeChild(el);
              });
              var planName = clone.textContent.trim();

              // Tint the table header column with the plan's brand color
              var accent = colorForPlan(planName, i);
              th.style.color = accent;
              th.style.borderColor = accent;
              th.style.borderBottomColor = accent;
              th.style.backgroundColor = accent + '0A';

              cardsHtml += '<div class="c-AICompare__plan-card" style="border-top-color:' + accent + ';--ai-compare-accent:' + accent + '">';
              cardsHtml += '<div class="c-AICompare__plan-card-header">';
              cardsHtml += '<span class="c-AICompare__plan-card-name" style="color:' + accent + '">' + planName + '</span>';
              if (purchaseLink) {
                cardsHtml += '<button type="button" class="o-Btn o-Btn--prim c-AICompare__plan-card-btn"'
                  + ' data-ai-purchase-link="' + safeLink + '">Purchase</button>';
              }
              cardsHtml += '</div><ul class="c-AICompare__plan-card-list">';

              bodyRows.forEach(function (row) {
                var cells     = [].slice.call(row.querySelectorAll('td'));
                var benefit   = cells[0] ? cells[0].textContent.trim() : '';
                var valueCell = cells[i + 1];
                // textContent for the yes/no detection; innerHTML to carry the
                // already-processed icon span (+ any trailing text node) into the card.
                var valueText = valueCell ? valueCell.textContent.trim() : '';
                var valueHtml = valueCell ? valueCell.innerHTML : valueText;
                var v   = valueText.toLowerCase();
                var isYesNo = v.startsWith('yes') || v === 'no' || v === 'not covered';

                cardsHtml += '<li>'
                  + '<span class="c-AICompare__plan-card-benefit">' + benefit + '</span>'
                  + '<span class="c-AICompare__plan-card-value">'
                  + (isYesNo ? valueHtml : valueText)
                  + '</span>'
                  + '</li>';
              });

              cardsHtml += '</ul></div>';
            });
            cardsHtml += '</div>';
          }

          // Carry the per-column header tint into the rendered table
          var tinted = doc.querySelector('table');
          if (tinted) tableHtml = tinted.outerHTML;
        } catch (e) {
          cardsHtml = '';
        }

        return cardsHtml + '<div class="c-AICompare__table-wrap">' + tableHtml + '</div>';
      });

      // Disclaimer blockquote(s) render as plain text in the chat (per Figma).
      // Tag them so non-compare messages keep their normal boxed blockquotes.
      html = html.replace(/<blockquote>/gi, '<blockquote class="c-AICompare__disclaimer">');

      // Wrap the whole compare response so its headings / list spacing can be
      // styled without affecting normal chat messages (no other parent existed).
      html = '<div class="c-AICompare__chat">' + html + '</div>';

      return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'code', 'pre', 'a', 'ul', 'ol', 'li', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'div', 'span', 'button'],
        ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'type', 'style', 'data-ai-purchase', 'data-ai-purchase-link']
      });
    },
    // Handle purchase button clicks inside assistant compare tables
    handleComparePurchaseClick(event) {
      const btn = event.target.closest && event.target.closest('[data-ai-purchase-link]');
      if (!btn) return;
      const link = btn.getAttribute('data-ai-purchase-link');
      if (link) {
        // These buttons are rendered as raw HTML (not Vue-bound), so the busy
        // state goes straight onto the node. Guard against a double-click
        // firing a second navigation while the first is in flight. (AIQ-470)
        if (btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        this.requestCsatFromCta(); // high-intent action (purchasing from compare)
        window.location.href = link;
      }
    },
    handleScroll() {
      // Check if user has scrolled up from bottom of page (with small threshold)
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const clientHeight = window.innerHeight;
      const isAtBottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 5;
      this.userHasScrolledUp = !isAtBottom;
    },
    insertNewline(e) {
      // Allow newline when Shift+Enter
      // Vue 2 will still pass, no extra handling needed
    },
    handleEnter() {
      if (!this.draft || this.isTyping) return;

      // If user is actively listening, stop recognition first
      if (this.isListening) {
        this.stopListening();
      }

      const content = this.draft;
      const isDefaultQuestion = this.nextSendIsDefault;
      this.nextSendIsDefault = false;
      this.pushUser(content, isDefaultQuestion);
      this.draft = '';
      this.error = '';
      // Reset composer size immediately
      this.$nextTick(() => {
        this.isComposerLarge = false;
        if (this.$refs.txtinput) {
          this.$refs.txtinput.style.height = '';
        }
      });
      this.fetchReply(content, isDefaultQuestion);
    },
    pushUser(text, isDefaultQuestion = false) {
      this.messages.push({
        id: 'u-' + Date.now() + '-' + Math.random().toString(36).slice(2),
        role: 'user',
        text,
        isDefaultQuestion,
        timestamp: Date.now()
      });
      this.userHasScrolledUp = false; // Reset scroll state when user sends message
      this.$nextTick(() => this.scrollToBottom(true));
      this.$emit('message:sent', text);
      // User re-engaged: cancel any pending feedback prompt and restart idle.
      this.cancelPendingCsat();
      this.resetCsatIdleTimer();
      this.saveSession();
    },
    pushAssistant(msg) {
      this.messages.push({
        id: 'a-' + Date.now() + '-' + Math.random().toString(36).slice(2),
        role: 'assistant',
        text: msg.text || '',
        messageId: msg.messageId || null,
        timestamp: Date.now(),
        feedback: null, // null, 'up', or 'down'
        plans: msg.plans || null, // Comprehensive plans for this message
        quoteLink: msg.quoteLink || null, // Quote link for this message
        section: msg.section || null, // Section tied to this specific message's plan blocks
        policyMax: msg.policyMax ?? null,
        ded: msg.ded ?? null,
        skipStreaming: msg.skipStreaming || false // Skip streaming for restored messages
      });
      this.$nextTick(this.scrollToBottom);
      this.$emit('message:received', msg.text);
      this.saveSession();
    },
    updateLatestPlanBlockSelections(policyMax, ded) {
      const hasPolicyMax = policyMax !== null && policyMax !== undefined;
      const hasDeductible = ded !== null && ded !== undefined;
      if (!hasPolicyMax && !hasDeductible) return;

      for (let index = this.messages.length - 1; index >= 0; index--) {
        const message = this.messages[index];
        if (message.role !== 'assistant' || !message.plans || message.plans.length === 0) continue;
        if (hasPolicyMax) this.$set(message, 'policyMax', policyMax);
        if (hasDeductible) this.$set(message, 'ded', ded);
        return;
      }
    },
    formatTimestamp(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const now = new Date();
      const isToday = date.toDateString() === now.toDateString();

      const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const displayHours = hours % 12 || 12;

      if (isToday) {
        return `${displayHours}:${minutes} ${ampm}`;
      } else {
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${month}/${day} ${displayHours}:${minutes} ${ampm}`;
      }
    },
    async submitFeedback(message, feedbackType) {
      if (!message || message.role !== 'assistant' || message.feedback) return;

      // Set feedback immediately for UI responsiveness
      this.$set(message, 'feedback', feedbackType);
      this.$set(message, 'feedbackSubmitted', true);
      
      // Hide the confirmation message after 2.5 seconds
      setTimeout(() => {
        this.$set(message, 'feedbackSubmitted', false);
        this.saveSession();
      }, 2500);

      try {
        // Call API to save feedback
        await fetch('/cognix/feedback', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            messageId: message.messageId,
            upVote: feedbackType === 'up',
            downVote: feedbackType !== 'up'
          })
        });
      } catch (e) {
        console.error('Failed to submit feedback:', e);
        // Keep the UI feedback even if API fails
      }
    },
    async fetchReply(userText, isDefaultQuestion = false) {
      this.isTyping = true;
      this.error = ''; // Clear any previous errors
      try {
        // --- PLACEHOLDER: wire your real API here ---
        // Option A) Replace this.sendToApi with your own function via mixin or local import
        const reply = await this.sendToApi(userText, isDefaultQuestion);
        // Only push assistant message if not session expired and reply exists
        if (!this.sessionExpired && reply) {
          this.pushAssistant(reply);
        } else if (!this.sessionExpired && reply === '' && !this.error) {
          // Empty string reply without error - show fallback message
          this.pushAssistant({ text: "I'm here—could you try that again?" });
        }
        // If reply is null, it means there was an error and this.error is already set
      } catch (e) {
        console.error("Tested: " + e);
        if (!this.sessionExpired) {
          this.error = 'Scout AI has encountered an error. Please refresh this page to continue.';
        }
      } finally {
        this.isTyping = false;
        this.$nextTick(this.scrollToBottom);
      }
    },
    retryMessage(message) {
      if (!message || message.role !== 'user' || this.isTyping) return;

      // Remove retry flag
      this.$set(message, 'needsRetry', false);

      // Clear any errors
      this.error = '';

      // Retry the API call with this message
      this.fetchReply(message.text, message.isDefaultQuestion === true);
    },
    async sendToApi(userText, isDefaultQuestion = false) {
      let userName = null;
      if (window.ctsJS) userName = window.ctsJS.currentUser;

      const res = await fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ userInput: userText, uuid: window.usun, userName, sessionId: this.sessionId })
      });
      const data = await res.json();

      // Check for errors in response
      if (data.success === false && data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
        // Set error message from the errors array
        this.error = data.errors.join(' ');
        return null; // Return null to prevent displaying assistant message
      }

      // Check for session expiration
      if (data.sessionExpired === true) {
        this.sessionExpired = true;
        this.saveSession(); // Save expired state
        return ''; // Return empty to prevent displaying chat message
      }

      if (data.sessionId) this.sessionId = data.sessionId;

      // Extract comprehensive plans (first 3) for this message
      let messagePlans = null;
      if (data.comprehensive && Array.isArray(data.comprehensive)) {
        messagePlans = data.comprehensive.slice(0, 3);
      }

      if (data.criteria && data.criteria.travelerInfos && data.criteria.travelerInfos.length > 0) {
        this.criteria = data.criteria;
      }

      if (data.section) this.section = data.section;

      // Extract quote link for this message
      let messageQuoteLink = data.quoteLink || null;

      // Prepare the response message
      let responseText = data.chatHistory && data.chatHistory.length > 0
        ? data.chatHistory[data.chatHistory.length - 1]
        : '';

      if (data.callBack === true) {
        responseText = this.getCallbackSupportMessage();
        messagePlans = null;
        messageQuoteLink = null;
      }

      if (data.callBack !== true && (!messagePlans || messagePlans.length === 0)) {
        this.updateLatestPlanBlockSelections(data.policyMax, data.ded);
      }

      // Check if the last message in chatHistory is the user's input (no assistant response)
      // This can happen when the API echoes back the user message without a response
      if (data.callBack !== true && responseText && responseText.trim().toLowerCase() === userText.trim().toLowerCase() && !data.quoteLink) {
        // No assistant response received, return empty to show fallback message
        return '';
      }

      // GTM + META intent events (chat_initiated / quote_completed). Placed
      // after the callback/echo checks above — those responses never carry a
      // real answer, so they must not count toward or fire these events even
      // if a stale non-zero intent came through.
      if (data.callBack !== true) this.trackChatIntent(data, isDefaultQuestion);

      if (messageQuoteLink) {
        // Check if we have plans to display
        if (messagePlans && messagePlans.length > 0) {
          this.saveSession(); // Save session with updated state
          responseText = 'We have generated your quote! Below are some popular plans based on your requirements. You can select one of these plans or click "View All Results" to see the complete list of available options.';
        } else if (messagePlans && messagePlans.length === 0) {
          this.saveSession(); // Save session with updated state
          responseText = `No insurance plans were found with the criteria entered, please check your entries and resubmit. You can [view your quote here](${messageQuoteLink}) to review the details or share it with a representative.`;
        } else {
          this.saveSession(); // Save session with updated state
          responseText = 'We have generated your quote! Click "View All Results" below to see all available plans.';
        }
      }

      this.saveSession(); // Save session after API response
      return {
        text: responseText,
        messageId: data.messageId,
        plans: messagePlans,
        quoteLink: messageQuoteLink,
        section: data.section || null,
        policyMax: data.policyMax ?? null,
        ded: data.ded ?? null
      };
    },
    // GA4 (via GTM dataLayer) + META pixel events driven by the backend's
    // intent classification on /cognix/question responses:
    //   - chat_initiated: once per session, on the 2nd real typed question
    //     (intent 4/3/1), or immediately if the very first response already
    //     completes a quote.
    //   - quote_completed: every time a response actually returns a quote
    //     link (intent 2 alone just means "this message gave quote details" —
    //     it fires on every info-gathering turn, long before a quote exists —
    //     so completion is judged by quoteLink being present, not by intent).
    // Default/suggested questions and intent 0 never count or fire.
    // Wrapped so analytics can never break the chat.
    trackChatIntent(data, isDefaultQuestion) {
      try {
        const intent = parseInt(data.intent, 10);
        if (isDefaultQuestion || isNaN(intent) || intent <= 0) return;

        const base = {
          uuid: window.usun || null,
          session_id: this.sessionId || null
        };
        const isQuoteCompleted = intent === 2 && !!data.quoteLink;

        this.chatAttempts += 1;
        if (!this.chatInitiatedFired && (isQuoteCompleted || this.chatAttempts >= 2)) {
          this.chatInitiatedFired = true;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(Object.assign({ event: 'ai_chat_initiated' }, base));
          if (typeof fbq === 'function') fbq('trackCustom', 'ai_chat_initiated', base);
        }

        if (isQuoteCompleted) {
          let fullQuoteId = null;
          try {
            fullQuoteId = new URL(`https://www.insubuy.com${data.quoteLink}`).searchParams.get('id') || null;
          } catch (e) { /* malformed quote link — send event without the id */ }
          const payload = Object.assign({ full_quote_id: fullQuoteId }, base);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(Object.assign({ event: 'ai_quote_completed' }, payload));
          if (typeof fbq === 'function') fbq('trackCustom', 'ai_quote_completed', payload);
        }
      } catch (e) { /* analytics must never break the chat */ }
    },
    scrollToBottom(force = false) {
      // Only auto-scroll if user hasn't scrolled up, or if forced
      if (force || !this.userHasScrolledUp) {
        // Use requestAnimationFrame for smoother scrolling
        requestAnimationFrame(() => {
          window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'
          });
        });
      }
    },
    onStreamingUpdate() {
      // Called during streaming updates - scroll smoothly if at bottom
      this.scrollToBottom();
    },
    onMessageDone() {
      // Only auto-focus the input on non-touch devices to prevent the
      // mobile keyboard from popping up and hiding the response.
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      if (!isTouchDevice) {
        this.$refs.txtinput?.focus();
      }
      // Speak the last assistant message only if voice input was used or voice is manually enabled
      if (this.voiceInputUsed || this.voiceEnabled) {
        const lastMessage = this.messages[this.messages.length - 1];
        if (lastMessage && lastMessage.role === 'assistant' && lastMessage.text) {
          this.speakText(lastMessage.text);
        }
      }
      // A reply finished — re-evaluate the feedback trigger and reset idle timer.
      this.evaluateCsatTrigger();
      this.resetCsatIdleTimer();
    },
    // ── Conversation feedback (CSAT) trigger ──────────────────────────────────
    // Composite, once-per-session: fire on the first value/engagement signal —
    // quote generated, compare shown, a plan CTA click, ≥2 substantive exchanges,
    // or an idle fallback. Greetings never count, so "hi" alone won't trigger it.
    // Greeting/one-word filter so trivial turns don't count as real exchanges.
    csatIsSubstantive(text) {
      const t = (text || '').trim();
      if (t.length < 15) return false;
      return !/^(hi|hey|hello|thanks|thank you|ok|okay|yes|no|yep|nope|sure|cool|great)\b[\s!.]*$/i.test(t);
    },
    csatSubstantiveTurns() {
      return this.messages.filter(m => m.role === 'user' && this.csatIsSubstantive(m.text)).length;
    },
    // Pick a reason from the latest reply and schedule with a read-time-aware
    // delay — longer for content-heavy moments so the user isn't rushed.
    evaluateCsatTrigger() {
      if (this.csatDone || this.showCsat) return;
      const last = this.messages[this.messages.length - 1];
      if (!last || last.role !== 'assistant') return;
      let delay = null;
      if (last.quoteLink || (last.plans && last.plans.length)) {
        delay = 8000;                          // quote + plan blocks — lots to read
      } else if (/\{\{PURCHASE:/i.test(last.text || '')) {
        delay = 8000;                          // compare module — lots to read
      } else if (this.csatSubstantiveTurns() >= 2) {
        delay = 4000;                          // engaged Q&A
      }
      if (delay !== null) this.scheduleCsat(delay);
    },
    // High-intent CTA clicks (View All Results / Purchase / Share).
    requestCsatFromCta() {
      this.scheduleCsat(3000);
    },
    scheduleCsat(delay) {
      if (this.csatDone || this.showCsat || this._csatTimer) return;
      this._csatTimer = setTimeout(() => {
        this._csatTimer = null;
        // Don't pop it mid-stream; the next completed reply will re-evaluate.
        if (this.csatDone || this.showCsat || this.isTyping || this.sessionExpired) return;
        this.showCsat = true;
        this.$nextTick(() => this.scrollToBottom());
      }, delay);
    },
    // Idle fallback so pure-Q&A users (who never hit quote/compare) still get asked.
    resetCsatIdleTimer() {
      if (this._csatIdleTimer) { clearTimeout(this._csatIdleTimer); this._csatIdleTimer = null; }
      if (this.csatDone) return;
      this._csatIdleTimer = setTimeout(() => {
        this._csatIdleTimer = null;
        if (this.csatSubstantiveTurns() >= 1) this.scheduleCsat(0);
      }, 30000);
    },
    clearCsatTimers() {
      this.cancelPendingCsat();
      if (this._csatIdleTimer) { clearTimeout(this._csatIdleTimer); this._csatIdleTimer = null; }
    },
    cancelPendingCsat() {
      if (this._csatTimer) { clearTimeout(this._csatTimer); this._csatTimer = null; }
    },
    // A star on the CSAT card opens the modal with that value preselected.
    openCsatModal(rating) {
      if (this.csatSubmitted) return;
      this.csatRating = rating;
      this.csatModalOpen = true;
      // Don't let the idle/CTA timers collapse the card while the modal is up.
      this.clearCsatTimers();
    },
    closeCsatModal() {
      this.csatModalOpen = false;
    },
    submitCsat(payload) {
      // Mark done immediately so it never re-prompts, even if the POST fails.
      this.csatDone = true;
      this.csatRating = payload.rating;
      this.csatSubmitted = true;
      this.csatModalOpen = false;
      this.clearCsatTimers();
      this.saveSession();
      try {
        fetch('/cognix/session-feedback', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: this.sessionId,
            rating: payload.rating,
            comment: payload.comment || '',
            uuid: window.usun || ''
          })
        }).catch(e => console.error('Failed to submit CSAT:', e));
      } catch (e) {
        console.error('Failed to submit CSAT:', e);
      }
      // Leave the "Thanks" state visible briefly, then collapse.
      setTimeout(() => { this.showCsat = false; }, 2500);
    },
    dismissCsat() {
      this.showCsat = false;
      this.csatModalOpen = false;
      this.csatDone = true;
      this.clearCsatTimers();
      this.saveSession();
    },
    // Public method for programmatic message sending (used by CTS for suggested questions)
    sendMessage(text, clearSession) {
      if (!text || this.isTyping || this.sessionExpired) return;
      if (clearSession) this.sessionId = null;
      // Programmatic/suggested question — exclude from intent tracking.
      this.pushUser(text, true);
      this.error = '';
      this.fetchReply(text, true);
    },
    // Voice Features
    initVoiceFeatures() {
      // Initialize Speech Recognition
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (SpeechRecognition) {
        this.recognition = new SpeechRecognition();
        // Disable continuous mode on Android - it has bugs that cause duplicate/repeated transcripts
        const isAndroid = /Android/i.test(navigator.userAgent);
        this.recognition.continuous = !isAndroid;
        this.recognition.interimResults = true;
        this.recognition.lang = 'en-US';
        this.recognition.maxAlternatives = 1;

        this.recognition.onstart = () => {
          this.isListening = true;
        };

        this.recognition.onresult = (event) => {
          let finalTranscript = '';
          let interimTranscript = '';

          // Process results from resultIndex to avoid re-processing old results
          for (let i = event.resultIndex; i < event.results.length; i++) {
            const transcript = event.results[i][0].transcript;
            if (event.results[i].isFinal) {
              // Append final result to accumulated transcript
              finalTranscript += transcript;
            } else {
              // Keep only the latest interim (replaces previous interim)
              interimTranscript = transcript;
            }
          }

          // Accumulate final transcripts
          if (finalTranscript) {
            this.voiceTranscript = (this.voiceTranscript + ' ' + finalTranscript).trim();
          }

          // Display: accumulated finals + current interim
          this.draft = (this.voiceTranscript + ' ' + interimTranscript).trim();
        };

        this.recognition.onend = () => {
          this.isListening = false;
          // Only auto-send if there's text and user manually stopped
          // (not if it stopped due to silence or error)
          if (this.draft && this.draft.trim() && !this.recognition.aborted) {
            // Small delay to ensure final transcript is captured
            setTimeout(() => {
              if (this.draft && this.draft.trim()) {
                this.handleEnter();
              }
            }, 300);
          }
        };

        this.recognition.onerror = (event) => {
          console.error('Speech recognition error:', event.error);
          this.isListening = false;

          // Don't show error for "no-speech" in continuous mode (it's normal to pause)
          if (event.error === 'no-speech') {
            // Just stop, don't show error
            return;
          } else if (event.error === 'aborted') {
            // User manually stopped, this is intentional
            return;
          } else if (event.error === 'not-allowed') {
            this.error = 'Microphone access denied. Please enable it in your browser settings.';
          } else if (event.error !== 'network') {
            // Don't show network errors as they're often transient
            this.error = 'Voice input error. Please try again.';
          }
        };
      }

      // Initialize Speech Synthesis
      if ('speechSynthesis' in window) {
        this.speechSynthesis = window.speechSynthesis;
      }
    },
    toggleVoiceInput() {
      if (this.isListening) {
        this.stopListening();
        this.toggleInactiveMic = true;
        setTimeout(() => {
          this.toggleInactiveMic = false;
        }, 1500);
      } else {
        this.startListening();
      }
    },
    startListening() {
      if (!this.recognition) {
        this.error = 'Voice input is not supported in your browser.';
        return;
      }

      // Stop any current speech
      this.stopSpeaking();

      // Clear draft and transcript before starting
      this.draft = '';
      this.voiceTranscript = '';
      this.error = '';

      // Mark that voice input is being used
      this.voiceInputUsed = true;

      try {
        this.recognition.start();
      } catch (e) {
        console.error('Failed to start recognition:', e);
        this.error = 'Failed to start voice input. Please try again.';
      }
    },
    stopListening() {
      if (this.recognition && this.isListening) {
        this.recognition.stop();
      }
    },
    speakText(text) {
      // Only speak if voice input was used or voice output is manually enabled
      if (!this.speechSynthesis || (!this.voiceEnabled && !this.voiceInputUsed) || !text) return;

      // Stop any ongoing speech
      this.stopSpeaking();

      // Remove markdown formatting for better speech
      const cleanText = text
        .replace(/#{1,6}\s/g, '') // Remove markdown headers
        .replace(/\*\*(.+?)\*\*/g, '$1') // Remove bold
        .replace(/\*(.+?)\*/g, '$1') // Remove italic
        .replace(/\[(.+?)\]\(.+?\)/g, '$1') // Remove links
        .replace(/`(.+?)`/g, '$1') // Remove code blocks
        .replace(/<[^>]*>/g, '') // Remove HTML tags
        .replace(/&nbsp;/g, ' ') // Replace nbsp
        .replace(/\n+/g, '. '); // Replace newlines with periods

      const utterance = new SpeechSynthesisUtterance(cleanText);

      // Select a natural voice (prefer female English voice)
      const voices = this.speechSynthesis.getVoices();
      const preferredVoice = voices.find(voice =>
        voice.lang.startsWith('en') &&
        (voice.name.includes('Female') || voice.name.includes('Samantha') || voice.name.includes('Google'))
      ) || voices.find(voice => voice.lang.startsWith('en'));

      if (preferredVoice) {
        utterance.voice = preferredVoice;
      }

      // Configure for natural speech
      utterance.rate = 1.0; // Normal speed
      utterance.pitch = 1.0; // Normal pitch
      utterance.volume = 1.0; // Full volume

      utterance.onstart = () => {
        this.isSpeaking = true;
      };

      utterance.onend = () => {
        this.isSpeaking = false;
        this.currentUtterance = null;
        // Reset voice input flag after speaking the response
        this.voiceInputUsed = false;
      };

      utterance.onerror = (event) => {
        // Ignore 'interrupted' errors - these are expected when speech is cancelled
        // (e.g., when user starts voice input or manually stops speech)
        if (event.error === 'interrupted' || event.error === 'cancelled') {
          this.isSpeaking = false;
          this.currentUtterance = null;
          this.voiceInputUsed = false;
          return;
        }

        // Log other errors for debugging
        console.error('Speech synthesis error:', event);
        this.isSpeaking = false;
        this.currentUtterance = null;
        // Reset voice input flag on error as well
        this.voiceInputUsed = false;
      };

      this.currentUtterance = utterance;
      this.speechSynthesis.speak(utterance);
    },
    stopSpeaking() {
      if (this.speechSynthesis && this.isSpeaking) {
        this.speechSynthesis.cancel();
        this.isSpeaking = false;
        this.currentUtterance = null;
      }
    },
    /**
     * Toggle read aloud functionality
     * When disabled: stops speaking and resets voice input flag
     * When enabled: sets voiceEnabled to true for manual control
     */
    toggleReadAloud() {
      // If currently active (either manually enabled or via voice input)
      if (this.voiceEnabled || this.voiceInputUsed) {
        // Disable read aloud
        this.voiceEnabled = false;
        this.voiceInputUsed = false;
        this.stopSpeaking();
        this.toggleInactiveSpk = true;
        setTimeout(() => {
          this.toggleInactiveSpk = false;
        }, 1500);
      } else {
        // Enable read aloud manually
        this.voiceEnabled = true;
      }
    },
    clearSessionAndConversations() {
      // Clear sessionId
      this.sessionId = null;

      // Clear all messages
      this.messages = [];

      // Clear session storage
      this.clearSession();

      // Reset session expired state
      this.sessionExpired = false;

      // Reset feedback so a fresh conversation can be rated again
      this.clearCsatTimers();
      this.showCsat = false;
      this.csatDone = false;
      this.csatRating = 0;
      this.csatSubmitted = false;
      this.csatModalOpen = false;

      // Reset intent tracking for the fresh session
      this.chatAttempts = 0;
      this.chatInitiatedFired = false;
      this.nextSendIsDefault = false;

      // Note: No welcome message is pushed - welcome screen will show automatically

      // Focus on input
      this.$nextTick(() => {
        this.$refs.txtinput?.focus();
      });
    },
    handleFaqClick(question) {
      // When a FAQ is clicked, send it as a message
      if (this.isTyping || this.sessionExpired) return;

      this.draft = question;
      this.inputFocused = false; // Hide the FAQ suggestions
      this.nextSendIsDefault = true; // default question — exclude from intent tracking
      this.handleEnter();
    },
    handleInputFocus() {
      this.inputFocused = true;
    },
    handleInputBlur() {
      // Delay blur to allow clicking on FAQ suggestions
      setTimeout(() => {
        this.inputFocused = false;
      }, 200);
    },
    copySessionId() {
      if (!this.sessionId) {
        this.error = 'No session ID to copy';
        setTimeout(() => {
          this.error = '';
        }, 2000);
        return;
      }

      // Copy to clipboard
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.sessionId).then(() => {
          // Show success message temporarily
          const originalError = this.error;
          this.error = 'Session ID copied to clipboard!';
          setTimeout(() => {
            this.error = originalError;
          }, 2000);
        }).catch(err => {
          console.error('Failed to copy session ID:', err);
          this.error = 'Failed to copy session ID';
          setTimeout(() => {
            this.error = '';
          }, 2000);
        });
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = this.sessionId;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.error = 'Session ID copied to clipboard!';
          setTimeout(() => {
            this.error = '';
          }, 2000);
        } catch (err) {
          console.error('Fallback: Failed to copy session ID:', err);
          this.error = 'Failed to copy session ID';
          setTimeout(() => {
            this.error = '';
          }, 2000);
        }
        document.body.removeChild(textArea);
      }
    },
    initLogoAnimation() {
      const wrap = document.querySelector(".logo-wrap");
      if (!wrap) return;

      const svg = wrap.querySelector("svg");
      if (!svg) return;

      const fg = Array.from(svg.querySelectorAll('path:not([opacity])'));
      fg.forEach((el, i) => (el.style.animationDelay = `${i * 35}ms`));

      requestAnimationFrame(() => wrap.classList.add("phase1"));

      setTimeout(() => {
        wrap.classList.add("phase2");
      }, 420);

      // 🔥 after blast-in completes, lock bg visible
      setTimeout(() => {
        wrap.classList.add("bg-ready");
      }, 800); // should be >= your longest blast duration (720ms)

      // 🔥 start glow after everything appears
      setTimeout(() => {
        wrap.classList.add("phase3");
      }, 1200);
    },
    openScoutPromoVideo() {
      const url = '/guide/terms?section=scoutpromovideo'
      global.eventHub.$emit('show-modal', url);
    }
  }
};
</script>

<style lang="scss" src="./component.ai-chat.scss"></style>
